var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMcom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-235"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-235",
    d: "M79.55,231.2c-94.13,54.35-94.13,142.46,0,196.81s246.75,54.35,340.89,0,94.13-142.46,0-196.81S173.69,176.85,79.55,231.2Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-235"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-235",
    d: "M394.89,374.13l-10.43-6a8,8,0,0,0-7.64.19L323,397.21c-10.51-6.13-25-9.93-41.07-9.93-32.09,0-58.1,15.19-58.1,33.92s26,33.92,58.1,33.92S340,439.93,340,421.2c0-6-2.67-11.61-7.34-16.5l62.14-26.28C397,377.29,397,375.37,394.89,374.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-235",
    d: "M190,423.91a12.47,12.47,0,0,1-6.17-1.51L83.72,364.62l-15.91,3a6.79,6.79,0,0,1-1.35.13,7.32,7.32,0,0,1-3.66-1L20.9,342.63a7.33,7.33,0,0,1-2.46-10.38l.07-.1,2.66-3.65-4.06-2.34a5.61,5.61,0,0,1,0-10.28l137.17-79.71L336.5,341.37l-140.35,81A12.47,12.47,0,0,1,190,423.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-235",
    d: "M370.18,311.93,468,255.48c2.52-1.46,2.52-3.81,0-5.27L337,174.6a10,10,0,0,0-9.12,0l-97.78,56.45c-2.51,1.45-2.51,3.81,0,5.26l131,75.62A10.08,10.08,0,0,0,370.18,311.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-235",
    points: "419.69 370.74 357.77 334.99 416.49 301.13 478.42 336.88 419.69 370.74",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-235",
    d: "M183.72,443l-9.44-10.73h0l-71.11-41.19h0l-2-1.16-3.26-1.89-.22-.12a.11.11,0,0,1,.07,0l-3.14-1.8v0l-12.83-7.39c-2.47-1.69-6.19,1.75-7.63,5.21h0a9,9,0,0,0-.5,1.61c-.28,1.44,0,2.74,1,3.47l10.46,6L88,396.73l0,0,2.35,1.35.22.12,2.71,1.57h0l.11.08,2.28,1.3L168,443.06h0l13.78,2.72,3.74.75a.57.57,0,0,0,.48-.14.53.53,0,0,0,0-.75Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-235"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Gear--inject-235",
    d: "M87.29,101.81l-5.14,6.26a3,3,0,0,1-2.89.8,28.24,28.24,0,0,0-4.34-.86c-.94-.11-2.06-1.35-2.5-2.84l-1.73-5.78c-.44-1.49-1.51-2.55-2.38-2.37l-8.93,1.85c-.88.19-1.49,1.5-1.38,2.95l.49,6.43c.11,1.44-.44,2.94-1.22,3.38a29.94,29.94,0,0,0-4,2.71,3,3,0,0,1-3.06.14L43.76,111a2.17,2.17,0,0,0-2.79.59l-4.9,7.46a2.47,2.47,0,0,0,.72,3L42,126.6a3.75,3.75,0,0,1,1.12,3.54,30.9,30.9,0,0,0-.74,3.64c-.19,1.27-.93,2.59-1.77,2.87l-7.84,2.56c-.85.27-1.3,1.7-1,3.19l1.3,7c.28,1.49,1.23,2.63,2.13,2.55l8.09-.75c.9-.09,2.15,1,2.91,2.29a25.94,25.94,0,0,0,1.51,2.34,4.05,4.05,0,0,1,.7,3.74l-3.57,7a2.39,2.39,0,0,0,.89,2.94l6.63,4.57a2.19,2.19,0,0,0,2.89-.15l5.15-6.26a3,3,0,0,1,2.88-.8,28.24,28.24,0,0,0,4.34.86c.94.11,2.06,1.35,2.5,2.84l1.73,5.78c.45,1.49,1.51,2.55,2.39,2.36l8.93-1.85c.87-.18,1.49-1.5,1.37-2.94L84,167.47c-.11-1.45.45-2.94,1.22-3.38a29.94,29.94,0,0,0,4-2.71,3,3,0,0,1,3.06-.14l6.48,3.47a2.16,2.16,0,0,0,2.79-.59l4.9-7.47a2.46,2.46,0,0,0-.72-3l-5.18-4.49a3.75,3.75,0,0,1-1.12-3.54,30.94,30.94,0,0,0,.75-3.64c.18-1.27.92-2.59,1.77-2.87l7.84-2.56c.84-.27,1.3-1.7,1-3.19l-1.3-7c-.28-1.49-1.23-2.63-2.13-2.55l-8.09.75c-.9.09-2.15-1-2.91-2.29a25.94,25.94,0,0,0-1.51-2.34,4.07,4.07,0,0,1-.7-3.75l3.57-7a2.39,2.39,0,0,0-.89-2.94l-6.63-4.57A2.19,2.19,0,0,0,87.29,101.81Zm-6.43,21.4a17.82,17.82,0,0,1,4.52,24.38,16.9,16.9,0,0,1-23.76,4.92,17.82,17.82,0,0,1-4.52-24.38A16.89,16.89,0,0,1,80.86,123.21Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--gear--inject-235",
    d: "M151.93,82.15l-3.59,4.38a2.09,2.09,0,0,1-2,.56,19.8,19.8,0,0,0-3-.6c-.66-.08-1.44-.95-1.75-2l-1.2-4c-.32-1-1.06-1.77-1.67-1.65l-6.24,1.3c-.61.12-1,1-1,2l.34,4.49A2.68,2.68,0,0,1,131,89a20.63,20.63,0,0,0-2.78,1.89,2.06,2.06,0,0,1-2.13.1l-4.53-2.42a1.5,1.5,0,0,0-2,.41l-3.43,5.21a1.73,1.73,0,0,0,.51,2.13l3.62,3.14a2.61,2.61,0,0,1,.78,2.47,20.43,20.43,0,0,0-.52,2.54,2.56,2.56,0,0,1-1.24,2l-5.47,1.79c-.59.19-.91,1.19-.72,2.23l.91,4.9c.19,1,.86,1.84,1.49,1.78l5.65-.52c.63-.06,1.5.69,2,1.6.33.56.68,1.11,1.06,1.64a2.82,2.82,0,0,1,.48,2.61l-2.49,4.86a1.69,1.69,0,0,0,.62,2.06l4.63,3.18a1.53,1.53,0,0,0,2-.1l3.59-4.37a2.09,2.09,0,0,1,2-.56,19.8,19.8,0,0,0,3,.6c.66.08,1.44,1,1.75,2l1.2,4c.31,1,1.06,1.77,1.67,1.65l6.24-1.3c.61-.12,1-1,1-2.06l-.34-4.49a2.67,2.67,0,0,1,.85-2.36,20.63,20.63,0,0,0,2.78-1.89,2.06,2.06,0,0,1,2.13-.1l4.53,2.42a1.5,1.5,0,0,0,2-.41l3.43-5.21a1.73,1.73,0,0,0-.51-2.13l-3.62-3.14a2.61,2.61,0,0,1-.78-2.47,20.43,20.43,0,0,0,.52-2.54,2.56,2.56,0,0,1,1.24-2l5.47-1.79c.59-.19.91-1.19.72-2.23l-.91-4.9c-.19-1-.86-1.84-1.49-1.78l-5.65.52c-.63.06-1.5-.69-2-1.6-.33-.56-.68-1.11-1.06-1.64a2.82,2.82,0,0,1-.48-2.61l2.49-4.86a1.69,1.69,0,0,0-.62-2.06L154,82.05A1.56,1.56,0,0,0,151.93,82.15Zm-4.49,15a12.45,12.45,0,0,1,3.16,17,11.8,11.8,0,0,1-16.6,3.44,12.46,12.46,0,0,1-3.16-17A11.8,11.8,0,0,1,147.44,97.11Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Books--inject-235"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--books--inject-235"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Book--inject-235"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M457.54,254.28,454,252.36l3.27-.79A2.53,2.53,0,0,1,457.54,254.28Z",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.54,254.28,454,252.36l3.27-.79A2.53,2.53,0,0,1,457.54,254.28Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.38,302.2a8.11,8.11,0,0,0,7.31,0l82-47.35L328.93,185.12l-2.87-1.66-82,46.19c-2,1.17-2,3.07,0,4.22Z",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.17,213.9l28.6,16.46,18.51-10.68,21.54,12.44v14.37c0,1.88-2.11,4.56-2.88,4.12a20.77,20.77,0,0,0-4.11,1.46,30.94,30.94,0,0,0-5.95,4.4l-65.71-36.79Z",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.17,213.9l28.6,16.46,18.51-10.68,21.54,12.44v14.37c0,1.88-2.11,4.56-2.88,4.12a20.77,20.77,0,0,0-4.11,1.46,30.94,30.94,0,0,0-5.95,4.4l-65.71-36.79Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450,233.85v15.6a2.63,2.63,0,0,1,.26-.16,7.31,7.31,0,0,1,3.5-1.1,3.58,3.58,0,0,1,2.3.55v-18.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446,254.8a4.88,4.88,0,0,1,1-2.66,9,9,0,0,1,1-1.15l.35-.33.45-.38.37-.28c.27-.2.55-.38.81-.55V233.92l-4,2.32v-.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.82,246.49c0,1.88-2.11,4.56-2.88,4.12h0l-2.88-1.87V236.88l2.89-5,1.57-.56,1.3.76Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,282.33v17.8a5,5,0,0,0,2.44-.58l9-5.19L446,254.8V236.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.11,215.46V228.9a5.42,5.42,0,0,0,2.43,4.22l106.08,61.24,9,5.19a4.91,4.91,0,0,0,2.43.58V284.34Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.93,162l122.76,70.88v1.64c0,.92,1.28,1.25,2.86.34s2.87-2,2.87-3.63l.15-1.56-125.08-72.2-.51-.3a1.77,1.77,0,0,0-.21.76v.76C331.77,159.6,330.51,161.06,328.93,162Z",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.93,162l122.76,70.88v1.64c0,.92,1.28,1.25,2.86.34s2.87-2,2.87-3.63l.15-1.56-125.08-72.2-.51-.3a1.77,1.77,0,0,0-.21.76v.76C331.77,159.6,330.51,161.06,328.93,162Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.69,280.22l80.18-46.3c1-.54,1.95-1,2.35-.76l-.53-.29L328.93,162l-1.43-.83c-.79-.46-2.53-.2-3.87.57l-79.57,45.94c-2,1.17-2,3.07,0,4.22l118.32,68.33A8.11,8.11,0,0,0,369.69,280.22Z",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,157.16l.51.3,125.08,72.2a.88.88,0,0,1,.27-.33l.42-.24.9-.52,1.11-.65a1.13,1.13,0,0,1,1.42.13.39.39,0,0,1,.14.12,2.58,2.58,0,0,1,.38.52,3.07,3.07,0,0,1,.32.71,6.4,6.4,0,0,1,.26.81c.07.31.12.62.18,1a5.22,5.22,0,0,1,.07.57c0,.16,0,.3,0,.47,0,.35,0,.71,0,1.09v-3.51c0-1.94-1.64-4.46-3.65-5.62L341.14,155.84c-2-1.17-4.94-1.36-6.51-.46l-1.49.87-.06,0c-.1.07-.35.21-.63.36a0,0,0,0,0,0,0A1.3,1.3,0,0,0,332,157.16Z",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.69,302.19l4.95-2.87,74.24-42.86a4.82,4.82,0,0,1,1-2.66,10.8,10.8,0,0,1,3.25-2.85,7.31,7.31,0,0,1,3.5-1.1,3.72,3.72,0,0,1,2.31.76,12.87,12.87,0,0,0,1.36-6.14h2.81c0,3.88-1.28,7.77-2.85,8.67l-1.42.83c-.8.47-1.43.49-1.43.06v-.76c0-.84-1.28-.8-2.87.11s-2.86,2.34-2.86,3.18v.76c0,.43-1.09,1.4-2.43,2.18L377.46,301l-7.77,4.48h0a7.56,7.56,0,0,1-3.64.86v-3.25A7.42,7.42,0,0,0,369.69,302.19Z",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.69,302.19l4.95-2.87,74.24-42.86a4.82,4.82,0,0,1,1-2.66,10.8,10.8,0,0,1,3.25-2.85,7.31,7.31,0,0,1,3.5-1.1,3.72,3.72,0,0,1,2.31.76,12.87,12.87,0,0,0,1.36-6.14h2.81c0,3.88-1.28,7.77-2.85,8.67l-1.42.83c-.8.47-1.43.49-1.43.06v-.76c0-.84-1.28-.8-2.87.11s-2.86,2.34-2.86,3.18v.76c0,.43-1.09,1.4-2.43,2.18L377.46,301l-7.77,4.48h0a7.56,7.56,0,0,1-3.64.86v-3.25A7.42,7.42,0,0,0,369.69,302.19Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.66,280.23h0l4.95-2.87,57-32.91,18.21-10.52c1.29-.76,2.35-1,2.42-.63a.06.06,0,0,1,0,0v.83c0,.92,1.28.92,2.86,0s2.22-2,2.25-2.87v-.9a1.28,1.28,0,0,1,.42-1.06,4.81,4.81,0,0,1,.42-.24l.9-.52,1.11-.65a1.13,1.13,0,0,1,1.42.13.39.39,0,0,1,.14.12,1.42,1.42,0,0,1,.25.34.75.75,0,0,1,.13.18,3.07,3.07,0,0,1,.32.71,6.4,6.4,0,0,1,.26.81c.07.31.12.62.18,1a5.22,5.22,0,0,1,.07.57c0,.16,0,.3,0,.47,0,.35,0,.71,0,1.09v11.17h-2.81V233.3c0-.29,0-.59,0-.87l-.07-.7a.17.17,0,0,0,0-.07c-.25,2.23-2.39,4.23-4.25,5.29a7.09,7.09,0,0,1-3.43,1.06,3.77,3.77,0,0,1-2.51-.92l-.26.14-.49.29L377.46,279l-7.77,4.49h0l-.05,0a7.6,7.6,0,0,1-3.59.83v-3.25A7.49,7.49,0,0,0,369.66,280.23Z",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.66,280.23h0l4.95-2.87,57-32.91,18.21-10.52c1.29-.76,2.35-1,2.42-.63a.06.06,0,0,1,0,0v.83c0,.92,1.28.92,2.86,0s2.22-2,2.25-2.87v-.9a1.28,1.28,0,0,1,.42-1.06,4.81,4.81,0,0,1,.42-.24l.9-.52,1.11-.65a1.13,1.13,0,0,1,1.42.13.39.39,0,0,1,.14.12,1.42,1.42,0,0,1,.25.34.75.75,0,0,1,.13.18,3.07,3.07,0,0,1,.32.71,6.4,6.4,0,0,1,.26.81c.07.31.12.62.18,1a5.22,5.22,0,0,1,.07.57c0,.16,0,.3,0,.47,0,.35,0,.71,0,1.09v11.17h-2.81V233.3c0-.29,0-.59,0-.87l-.07-.7a.17.17,0,0,0,0-.07c-.25,2.23-2.39,4.23-4.25,5.29a7.09,7.09,0,0,1-3.43,1.06,3.77,3.77,0,0,1-2.51-.92l-.26.14-.49.29L377.46,279l-7.77,4.49h0l-.05,0a7.6,7.6,0,0,1-3.59.83v-3.25A7.49,7.49,0,0,0,369.66,280.23Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.56,209.74v3.31a2.51,2.51,0,0,0,1.44,2.08l.06,0L354.62,279l7.76,4.49h0a7.67,7.67,0,0,0,3.64.86v-3.25a7.38,7.38,0,0,1-3.65-.87l-4.94-2.85h0L244.06,211.9A2.51,2.51,0,0,1,242.56,209.74Z",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.56,209.74v3.31a2.51,2.51,0,0,0,1.44,2.08l.06,0L354.62,279l7.76,4.49h0a7.67,7.67,0,0,0,3.64.86v-3.25a7.38,7.38,0,0,1-3.65-.87l-4.94-2.85h0L244.06,211.9A2.51,2.51,0,0,1,242.56,209.74Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.56,231.72V235A2.5,2.5,0,0,0,244,237.1l.06,0L354.62,301l7.76,4.48h0a7.56,7.56,0,0,0,3.64.86v-3.25a7.38,7.38,0,0,1-3.65-.87l-4.94-2.85h0L244.06,233.87A2.51,2.51,0,0,1,242.56,231.72Z",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.56,231.72V235A2.5,2.5,0,0,0,244,237.1l.06,0L354.62,301l7.76,4.48h0a7.56,7.56,0,0,0,3.64.86v-3.25a7.38,7.38,0,0,1-3.65-.87l-4.94-2.85h0L244.06,233.87A2.51,2.51,0,0,1,242.56,231.72Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--book--inject-235"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "457.57 218.28 361.69 272.89 234.17 199.72 330.05 145.09 457.57 218.28",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "457.57 218.28 361.69 272.89 234.17 199.72 330.05 145.09 457.57 218.28",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.81,269.55,454,216.21c-1.95-5.52-1.8-12,.4-19.31l-92.67,52.89S360.27,254.45,360.81,269.55Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.48,243.75a15.72,15.72,0,0,0-7.15,12.32v14.39c0,4.54,3.2,6.37,7.16,4.11l92.07-52.73v-3.56l-91.1,51.9c-2.37,1.36-4.29.25-4.28-2.47l.06-13.33a9.46,9.46,0,0,1,4.3-7.39l91-51.92v-4Z",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.48,243.75a15.72,15.72,0,0,0-7.15,12.32v14.39c0,4.54,3.2,6.37,7.16,4.11l92.07-52.73v-3.56l-91.1,51.9c-2.37,1.36-4.29.25-4.28-2.47l.06-13.33a9.46,9.46,0,0,1,4.3-7.39l91-51.92v-4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.56,191,330,117.86,238,170.58a15.7,15.7,0,0,0-7.16,12.32v14.39c0,2.26.8,3.85,2.1,4.6l127.51,73.18c-1.3-.75-2.09-2.34-2.1-4.6v-14.4a15.71,15.71,0,0,1,7.16-12.32Z",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.56,191,330,117.86,238,170.58a15.7,15.7,0,0,0-7.16,12.32v14.39c0,2.26.8,3.85,2.1,4.6l127.51,73.18c-1.3-.75-2.09-2.34-2.1-4.6v-14.4a15.71,15.71,0,0,1,7.16-12.32Z",
    style: {
      fill: "#fff",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.42,249.06a14.53,14.53,0,0,0-2.1,7v14.4c0,2.26.8,3.85,2.1,4.6L232.92,201.89c-1.3-.75-2.1-2.34-2.1-4.6V182.9a14.42,14.42,0,0,1,2.1-7Z",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.42,249.06a14.53,14.53,0,0,0-2.1,7v14.4c0,2.26.8,3.85,2.1,4.6L232.92,201.89c-1.3-.75-2.1-2.34-2.1-4.6V182.9a14.42,14.42,0,0,1,2.1-7Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.73,185.43c-2.32,10.07-2.29,18.77,0,26.16l5.93,3.42c-2.29-7.39-2.32-16.09,0-26.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.42,234.33c-2.32,10.07-2.28,18.77,0,26.16l5.92,3.42c-2.28-7.39-2.31-16.09,0-26.16Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Folder--inject-235"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--folder--inject-235"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.47,321.66c-2.65-1.53-2.66-4,0-5.56l135.82-78.92L331.05,339.23,194.79,417.91a10.65,10.65,0,0,1-9.62,0l-101-58.29-16.9,3.18a4.56,4.56,0,0,1-3.15-.53l-41.9-24.14a4.6,4.6,0,0,1-1.54-6.52l4.43-6.09Z",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.47,321.66c-2.65-1.53-2.66-4,0-5.56l135.82-78.92L331.05,339.23,194.79,417.91a10.65,10.65,0,0,1-9.62,0l-101-58.29-16.9,3.18a4.56,4.56,0,0,1-3.15-.53l-41.9-24.14a4.6,4.6,0,0,1-1.54-6.52l4.43-6.09Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.86 240.38 325.07 335.79 189.98 413.18 25.72 318.31 159.86 240.38",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.25,339.35l-123,70.72a10.34,10.34,0,0,1-9.36-.16L32.2,313.67c-2.66-1.53-2.77-3.95-.26-5.41l122.53-71Z",
    style: {
      fill: "#366E47"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--magnifying-glass--inject-235"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--magnifying-glass--inject-235"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.62,357.14h0l-40.94,23.52h0l-.06,0h0a4,4,0,0,0-1.76,3.48,12.33,12.33,0,0,0,5.08,9.92,3.92,3.92,0,0,0,3.92.59l43-19.09h0a10.33,10.33,0,1,0-9.23-18.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.83,394.7l43-19.09A10.33,10.33,0,0,0,386.7,358c2.42,2.5,1.77,8.78-5.29,12.48s-33.54,15.68-45.58,21.8a9.53,9.53,0,0,0,2.08,1.86A3.92,3.92,0,0,0,341.83,394.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.83,384.21a12.31,12.31,0,0,0,5.1,9.91,3.93,3.93,0,0,0,3.81.63c.75-.35,3.65-1.63,4.43-2,1.13-.51,1.89-1.79,2-3.69a12.7,12.7,0,0,0-5.25-10.22c-1.59-1-3.07-1.16-4.14-.54-.75.42-4.18,2.4-4.18,2.4A4,4,0,0,0,332.83,384.21Z",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.83,384.21c.17-3.55,2.74-4.86,5.72-2.94a12.33,12.33,0,0,1,5.1,9.91c-.18,3.55-2.74,4.87-5.72,2.94A12.31,12.31,0,0,1,332.83,384.21Z",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.83,384.21c.17-3.55,2.74-4.86,5.72-2.94a12.33,12.33,0,0,1,5.1,9.91c-.18,3.55-2.74,4.87-5.72,2.94A12.31,12.31,0,0,1,332.83,384.21Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.13,400.14a8.18,8.18,0,0,1-3.43-6.54,2.62,2.62,0,0,1,1.17-2.34h0L335,383.39h0a2.58,2.58,0,0,1,2.58.37,8.18,8.18,0,0,1,3.43,6.54,2.61,2.61,0,0,1-1.18,2.34h0l-15.11,7.87h0A2.59,2.59,0,0,1,322.13,400.14Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.73,400.5a2.59,2.59,0,0,1-2.6-.36,7,7,0,0,1-2-2l20.36-10.6a7.14,7.14,0,0,1,.52,2.77,2.61,2.61,0,0,1-1.18,2.34l-15.11,7.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.22,403.5v14.67c0,8,5.26,15.92,15.78,22,21.05,12.15,55.17,12.15,76.22,0,10.52-6.08,15.78-14,15.79-22V403.5h0c0-8-5.27-15.93-15.79-22-21.05-12.15-55.17-12.15-76.22,0-10.52,6.07-15.78,14-15.78,22Zm102.57,0c0,6.37-4.68,12.58-13.18,17.49-9.4,5.42-22,8.41-35.5,8.41s-26.1-3-35.5-8.41c-8.5-4.91-13.18-11.12-13.18-17.49s4.68-12.58,13.18-17.49c9.4-5.43,22-8.42,35.5-8.42s26.11,3,35.5,8.42C326.11,390.92,330.79,397.13,330.79,403.5Z",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.22,403.5v14.67c0,8,5.26,15.92,15.78,22,21.05,12.15,55.17,12.15,76.22,0,10.52-6.08,15.78-14,15.79-22V403.5h0c0-8-5.27-15.93-15.79-22-21.05-12.15-55.17-12.15-76.22,0-10.52,6.07-15.78,14-15.78,22Zm102.57,0c0,6.37-4.68,12.58-13.18,17.49-9.4,5.42-22,8.41-35.5,8.41s-26.1-3-35.5-8.41c-8.5-4.91-13.18-11.12-13.18-17.49s4.68-12.58,13.18-17.49c9.4-5.43,22-8.42,35.5-8.42s26.11,3,35.5,8.42C326.11,390.92,330.79,397.13,330.79,403.5Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.26,395.46a14.83,14.83,0,0,1,2.53,8c0,6.37-4.68,12.58-13.18,17.49a58.44,58.44,0,0,1-13.38,5.5v20.05a64.9,64.9,0,0,0,16-6.37c10.52-6.08,15.78-14,15.79-22V403.5a20,20,0,0,0-3.38-10.83Z",
    style: {
      fill: "#366E47",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.22,403.5h0v14.67c0,8,5.26,15.92,15.78,22a60.59,60.59,0,0,0,9.28,4.28l.08-20.21a53.34,53.34,0,0,1-6.75-3.25c-8.5-4.91-13.18-11.12-13.18-17.49a14.16,14.16,0,0,1,1.53-6.26l-4.07-3.41A19.58,19.58,0,0,0,228.22,403.5Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.22,381.5c-21-12.15-55.17-12.15-76.21,0s-21,31.85,0,44,55.17,12.15,76.21,0S341.27,393.65,320.22,381.5ZM317.62,421c-9.4,5.42-22,8.41-35.5,8.41s-26.11-3-35.51-8.41c-8.49-4.91-13.17-11.12-13.17-17.49s4.67-12.58,13.17-17.49c9.4-5.43,22-8.42,35.51-8.42s26.1,3,35.5,8.42c8.5,4.91,13.18,11.12,13.18,17.49S326.12,416.08,317.62,421Z",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.22,381.5c-21-12.15-55.17-12.15-76.21,0s-21,31.85,0,44,55.17,12.15,76.21,0S341.27,393.65,320.22,381.5ZM317.62,421c-9.4,5.42-22,8.41-35.5,8.41s-26.11-3-35.51-8.41c-8.49-4.91-13.17-11.12-13.17-17.49s4.67-12.58,13.17-17.49c9.4-5.43,22-8.42,35.51-8.42s26.1,3,35.5,8.42c8.5,4.91,13.18,11.12,13.18,17.49S326.12,416.08,317.62,421Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M234.47,388.8a23.77,23.77,0,0,0-5.94,10.41,18.88,18.88,0,0,0,1.05,11.93,27.9,27.9,0,0,0,7.25,9.66,42.86,42.86,0,0,0,4.83,3.66c.85.55,1.7,1.09,2.59,1.57l2.69,1.4a25.18,25.18,0,0,0,2.74,1.27c.93.4,1.86.81,2.79,1.18l2.86,1,1.44.49c.48.16,1,.27,1.45.41a88.94,88.94,0,0,0,47.79,0c.48-.14,1-.25,1.45-.41l1.44-.49,2.86-1c.94-.37,1.86-.78,2.79-1.17s1.86-.78,2.75-1.27L320,426c.89-.48,1.74-1,2.59-1.56a44.29,44.29,0,0,0,4.84-3.67,27.87,27.87,0,0,0,7.24-9.66,18.81,18.81,0,0,0,1.05-11.93,23.77,23.77,0,0,0-5.94-10.41,40.58,40.58,0,0,0-9.54-7.3,40.8,40.8,0,0,1,9.39,7.44,23.5,23.5,0,0,1,5.69,10.37,18.35,18.35,0,0,1-1.14,11.62,27.25,27.25,0,0,1-7.18,9.39,46.22,46.22,0,0,1-10,6.47,24.52,24.52,0,0,1-2.71,1.24c-.92.39-1.84.79-2.76,1.16l-2.84,1-1.42.48c-.47.15-1,.26-1.44.4a90.34,90.34,0,0,1-47.37,0c-.48-.13-1-.25-1.44-.4l-1.42-.48-2.84-1c-.92-.37-1.83-.77-2.76-1.16a25.4,25.4,0,0,1-2.71-1.24,46.22,46.22,0,0,1-10-6.47,27.25,27.25,0,0,1-7.18-9.39,18.35,18.35,0,0,1-1.14-11.62,23.5,23.5,0,0,1,5.69-10.37A40.53,40.53,0,0,1,244,381.5,40.78,40.78,0,0,0,234.47,388.8Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.8,403.5a14.45,14.45,0,0,1-2.11,7.34c-2.13-3.71-5.9-7.18-11.08-10.16-9.39-5.43-22-8.42-35.5-8.42s-26.1,3-35.49,8.42c-5.18,3-9,6.45-11.09,10.16a14.53,14.53,0,0,1-2.1-7.34c0-6.37,4.68-12.58,13.19-17.49,9.39-5.42,22-8.42,35.49-8.42s26.11,3,35.5,8.42C326.12,390.92,330.8,397.13,330.8,403.5Z",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.8,403.5a14.45,14.45,0,0,1-2.11,7.34c-2.13-3.71-5.9-7.18-11.08-10.16-9.39-5.43-22-8.42-35.5-8.42s-26.1,3-35.49,8.42c-5.18,3-9,6.45-11.09,10.16a14.53,14.53,0,0,1-2.1-7.34c0-6.37,4.68-12.58,13.19-17.49,9.39-5.42,22-8.42,35.49-8.42s26.11,3,35.5,8.42C326.12,390.92,330.8,397.13,330.8,403.5Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.62,386c-8.51,4.91-13.19,11.12-13.19,17.49a14.53,14.53,0,0,0,2.1,7.34c2.14-3.71,5.91-7.18,11.09-10.16a53.5,53.5,0,0,1,6.8-3.28c-2,.8-8.35,2.82-6.06-3.19,2.74-7.14,16.07-14.87,25.87-16.15v0C263.16,379.06,253.91,381.8,246.62,386Z",
    style: {
      fill: "#366E47",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.62,392.65c-9.4-5.43-22-8.41-35.5-8.41s-26.11,3-35.51,8.41c-7,4.05-11.41,9-12.74,14.17,1.33,5.18,5.73,10.12,12.74,14.17,9.4,5.42,22,8.41,35.51,8.41s26.1-3,35.5-8.41c7-4.05,11.41-9,12.74-14.17C329,401.64,324.63,396.7,317.62,392.65Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pencil--inject-235"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pencil--inject-235"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pencil--inject-235"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.18,390.52l1.29.73,1.55.9,80.74,46.74c-.48-1.08-.11-3.24,1-5.31,1.28-2.41,3.25-4.32,4.67-4.39L95.1,382.69l-3-1.7C94,382.19,88.07,391.7,86.18,390.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,382.6,92.09,381c-.81-.5-2.36,1-3.72,2.91-1.81,2.57-3.28,6-2.2,6.65l2.12,1.22.76.42c-1.08-.67.39-4.08,2.2-6.66,1.3-1.86,2.79-3.29,3.62-2.94h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.25,382.2c-1.9-1.18-7.82,8.38-5.92,9.56l2.87,1.65c-1.89-1.17,4-10.73,5.92-9.56Z",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.86,385.43,97,383.79c-1.85-1.16-7.66,8-6.08,9.47a.73.73,0,0,0,.09.08L93.9,395C92,393.75,98,384.24,99.86,385.43Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.13,381v0l0,0c-.81-.52-2.36,1-3.72,2.9-1.79,2.53-3.25,5.87-2.24,6.61l-12-6.88a2.88,2.88,0,0,1-.94-3.13c.67-3.49,4.76-7.93,7.35-6.16Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.08,439.34c-1,1.34-.89,2-.89,2l-12.43-2.45c-1.24-1.88-.42-4.94,1.28-7.12l.55.31Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.57,442l-3.38-.66s-.16-.66.89-2L186,441.2h0a.48.48,0,0,1,0,.68A.47.47,0,0,1,185.57,442Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.42,429.19h0l8.53,9.67a1.49,1.49,0,0,0-.88.49l-11.49-7.26-.55-.31A6,6,0,0,1,175.42,429.19Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.08,439.34a1.17,1.17,0,0,1,.88-.49L186,441.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,431.77,74.42,377.56a8.9,8.9,0,0,0-1.2,2.91,2.88,2.88,0,0,0,.93,3.13l12,6.92,1.29.73,1.55.9,80.74,46.74C168.24,436.55,169.91,433.1,171,431.77Z",
    style: {
      opacity: 0.2
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Notes--inject-235"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--notes--inject-235"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "372.72 328.3 421.62 300.07 468.64 327.22 419.74 355.45 372.72 328.3",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.72 328.3 421.62 300.07 468.64 327.22 419.74 355.45 372.72 328.3",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.72 328.3 367.08 325.05 415.98 296.81 421.62 300.07 372.72 328.3",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.72 328.3 367.08 325.05 415.98 296.81 421.62 300.07 372.72 328.3",
    style: {
      fill: "#366E47",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.72 328.3 367.08 325.05 415.98 296.81 421.62 300.07 372.72 328.3",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.08 325.05 367.08 334.74 419.74 365.15 419.74 355.45 367.08 325.05",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.08 325.05 367.08 334.74 419.74 365.15 419.74 355.45 367.08 325.05",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.74 355.45 468.64 327.22 468.64 336.91 419.74 365.15 419.74 355.45",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.52,317.57h0l-37.9-17.5-48.9,28.23,47,21.72,42.32-24.43c2.58-1.5,5.09-4,4.93-7.34C465.52,319,463.15,319.25,459.52,317.57Z",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.52,317.57h0l-37.9-17.5-48.9,28.23,47,21.72,42.32-24.43c2.58-1.5,5.09-4,4.93-7.34C465.52,319,463.15,319.25,459.52,317.57Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.19,318.1,443,318c-.31-.25-.75.19-.54.39a7.42,7.42,0,0,0-1,.5,4.49,4.49,0,0,1-2.2.55.42.42,0,0,0,0-.1c.25-.91-.45-2.05-1.41-2.78a2.26,2.26,0,0,0-2.56-.32c-1,.59-.35,1.72.25,2.33a4.78,4.78,0,0,0,2.26,1.24,4.92,4.92,0,0,1-1.47.82c-.87.35-1.28.35-1.31,1.08a5.19,5.19,0,0,0,.22,1.15c.15.74,0,1.63-1.59,1.52a5.9,5.9,0,0,1-2-.56c-.31-.13-.63,0-.66.2-.09.61.18,1.24.15,1.85-.08,1.73-2.54,0-3.3-.51-.4-.27-.85,0-.7.3a4.28,4.28,0,0,1,0,3.11c-.13.5-.34,1.47-1.1,1.8a1.8,1.8,0,0,1-2-.35,6.13,6.13,0,0,0,.74-4.59,1.59,1.59,0,0,0-2.25-1.19c-1.8.52-1.6,2-1.25,2.9a9.69,9.69,0,0,0,1.87,2.92c-1,1.71-2.91,3.14-5.3,4.56-.31.18,0,.58.37.35,2.47-1.36,4.24-2.57,5.49-4.4a2.42,2.42,0,0,0,3.11.11,4.46,4.46,0,0,0,1.44-4.36,3.43,3.43,0,0,0,2.89.82c1.37-.44.84-1.85.71-2.77a5.06,5.06,0,0,0,3.46.32c1.6-.62.56-1.84.65-2.71s1.45-.91,2.37-1.56a2.74,2.74,0,0,0,.64-.63,5.14,5.14,0,0,0,4.25-1.57A.2.2,0,0,0,443.19,318.1Zm-19.72,11.48a9.48,9.48,0,0,1-.68-1c-.42-.66-1.56-2.4-.93-3.21a1,1,0,0,1,.27-.22,1.29,1.29,0,0,1,1.07-.08,1.38,1.38,0,0,1,.88,1.31,12.1,12.1,0,0,1-.11,1.34A5.76,5.76,0,0,1,423.47,329.58Zm14.87-10.41a3.81,3.81,0,0,1-2.29-1.08l0,0a1,1,0,0,1-.35-.64.78.78,0,0,1,.73-.74c.71-.07,1.11.44,1.48.93C438,317.71,438.64,319.2,438.34,319.17Zm-18.43,4.95a3.64,3.64,0,0,0,.58-2.38,15.31,15.31,0,0,0,0-1.66,7,7,0,0,0-.32-1c.92.55,1.73,1.27,3.15.84,2-.61,1.55-2.23,1.13-3.42,1.19.64,2.27,1.29,3.12-.12a4.05,4.05,0,0,1,1.59-1.85,9.51,9.51,0,0,0,1.55-1c1.08-1,.44-2.15,1.24-3.17.23-.29-.39-.6-.71-.28a1.68,1.68,0,0,0-.45,1c-.27,1.42-.89,2.16-2.61,3.21-.82.5-.9.89-1.41,1.44-1.21,1.27-1.71.3-2.85-.16-.33-.13-.71.07-.65.27.27.86,1.7,3.26-.76,3.4-1.27.08-1.67-.65-2.74-1s-.51,2.13-.41,2.61a7.58,7.58,0,0,1,.15,1.51,1.56,1.56,0,0,1-1.58,1.93,6.46,6.46,0,0,1-2.59-.2c.14-.33.47-.55.61-.91a2.69,2.69,0,0,0,.14-1.26,4.06,4.06,0,0,0-1.25-2.44,3.66,3.66,0,0,0-3.39-.84c-1.15.51-.55,2.17-.25,2.8a7,7,0,0,0,2.75,2.6,6.39,6.39,0,0,1-2.15.64c-1.22.19-2.19.11-2.57.92-.19.43.18,1.15-.25,1.5-.79.65-1.62,0-2.3,0-.92.1-1.2.26-1.21.87,0,.18.29.47.23.63l.15.23a2,2,0,0,1-1.23-.16c-.17,0-1.08-.39-1.07-.39a.58.58,0,0,0-.62.16A3.87,3.87,0,0,0,403,331c-1.33-1.83-2.24-3.68-4.76-5.2-1.36-.83-3.77-1.87-5.46-.74-2.57,1.71-1.7,6.34,1.81,7.46a.49.49,0,0,0,.41-.11l.29-.28c.24-.23-.14-.53-.47-.26-.66.55-2.27-2.34-2.33-2.54a3.71,3.71,0,0,1,.37-3.29c1.57-2.09,4.95.19,6.24,1.26,1.92,1.6,2.49,3.46,4,5.16.24.27.86.25.93-.07.24-1.14-.57-2.26-.29-3.37.95.44,2.57,1.24,3.18.41.29-.4-.33-.87-.14-1.29.29-.64.2-.25,1.11-.11a3.12,3.12,0,0,0,1,0,1.35,1.35,0,0,0,.84-.51c.76-.87-.11-1.79,1.85-2.3a12.31,12.31,0,0,0,3-.7l.25-.15.58.26C417.05,325.39,419.06,325.25,419.91,324.12Zm-5.4-.55a14.38,14.38,0,0,1-1.36-1,3,3,0,0,1-1.34-2.5,1.12,1.12,0,0,1,1.77-.64,3.6,3.6,0,0,1,1.51,2.54A1.88,1.88,0,0,1,414.51,323.57Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-235"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-235"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-235"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.34,126.56l-1.66-5.92c.72-3.4-13.15,4.61-13.87,8l4.47,12a1.84,1.84,0,0,0,.75.87c1,.61,7.6,4.36,7.92,4.56A1.93,1.93,0,0,0,250.8,145l5.79-19.85C257,123.51,253.76,124.61,250.34,126.56Z",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.34,126.56l-1.66-5.92c.72-3.4-13.15,4.61-13.87,8l4.47,12a1.84,1.84,0,0,0,.75.87c1,.61,7.6,4.36,7.92,4.56A1.93,1.93,0,0,0,250.8,145l5.79-19.85C257,123.51,253.76,124.61,250.34,126.56Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.18,44,213.45,74.4a3.94,3.94,0,0,0-1.79,3.09V140a3.89,3.89,0,0,0,1.8,3.07l6.27,3.56a4,4,0,0,0,3.57,0L276,116.17a4,4,0,0,0,1.78-3.09V50.59A3.9,3.9,0,0,0,276,47.52L269.76,44A4,4,0,0,0,266.18,44Z",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.18,44,213.45,74.4a3.94,3.94,0,0,0-1.79,3.09V140a3.89,3.89,0,0,0,1.8,3.07l6.27,3.56a4,4,0,0,0,3.57,0L276,116.17a4,4,0,0,0,1.78-3.09V50.59A3.9,3.9,0,0,0,276,47.52L269.76,44A4,4,0,0,0,266.18,44Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276,49.56,223.3,80a4,4,0,0,0-1.78,3.09v62.49c0,1.13.8,1.6,1.78,1L243.48,135l3.71,10.28a1.93,1.93,0,0,0,3.61-.19l4.93-17.16L276,116.17a4,4,0,0,0,1.78-3.09V50.59C277.82,49.46,277,49,276,49.56Z",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276,49.56,223.3,80a4,4,0,0,0-1.78,3.09v62.49c0,1.13.8,1.6,1.78,1L243.48,135l3.71,10.28a1.93,1.93,0,0,0,3.61-.19l4.93-17.16L276,116.17a4,4,0,0,0,1.78-3.09V50.59C277.82,49.46,277,49,276,49.56Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.8,50.27c-.14-.9-.88-1.22-1.76-.71L223.31,80a3.62,3.62,0,0,0-1.26,1.34l-9.83-5.65a3.49,3.49,0,0,1,1.23-1.27L266.19,44a4,4,0,0,1,3.57,0L276,47.52A4,4,0,0,1,277.8,50.27Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Check--inject-235",
    d: "M262.62,72.34a3.93,3.93,0,0,0-5.12,2.09l-14.77,35.16-3.52-3.43a3.91,3.91,0,0,0-5.45,5.61l7.63,7.42a3.89,3.89,0,0,0,2.72,1.1,3.44,3.44,0,0,0,.78-.08,3.91,3.91,0,0,0,2.83-2.31l17-40.44A3.92,3.92,0,0,0,262.62,72.34Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sheets--inject-235"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Papers--inject-235"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--sheets--inject-235"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-235",
    points: "26.8 288.78 164 209.58 347.08 315.49 209.89 394.69 26.8 288.78",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--sheets--inject-235"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-235"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "38.55 288.25 209.89 387.37 209.89 325.37 38.54 226.24 38.55 288.25",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.34 314.95 209.89 387.37 209.89 325.37 335.34 252.94 335.34 314.95",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "38.54 226.24 163.99 153.82 335.34 252.94 209.89 325.37 38.54 226.24",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "121.69 294.36 209.89 342.85 261.89 312.83 209.89 345.95 121.69 294.36",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.24 292.1 209.89 370.1 297.23 317.53 209.89 373.13 71.24 292.1",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.19,243.2s-2.87,16.19-1.43,24.39c0,0,22.69-.56,61,10Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52.19 243.2 111.75 277.59 45.85 258.57 52.19 243.2",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.24,290.14l65.3,60s1.82-8.25,14.35-14.05Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.24 290.14 157.57 341.77 175.89 336.12 96.24 290.14",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.84,276.34c-.34-.52-.55-.81-.55-.81L271,299.36l46.45-3.82C319.07,286.92,314.48,278.87,312.84,276.34Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.02 299.36 312.29 275.53 326.03 282.78 271.02 299.36",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "38.54 226.24 209.89 321.44 335.34 252.94 209.89 318.88 38.54 226.24",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "38.54 226.24 209.89 318.88 335.34 252.94 163.99 153.82 38.54 226.24",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,154.86l169.49,98-123.58,65L40.38,226.22,164,154.86m0-1L38.54,226.24l171.35,92.64,125.45-65.94L164,153.82Z",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.51,213.42a6.42,6.42,0,0,1,3-.93,5.09,5.09,0,0,1,2.77.68,2.28,2.28,0,0,1,1.11,1.12,1.22,1.22,0,0,1-.27,1.23l4.72.77.17.06a.18.18,0,0,1,.11.16.16.16,0,0,1-.11.15l-1,.6a.88.88,0,0,1-.48.14,2.12,2.12,0,0,1-.38,0l-4.46-.73-1.63.95,2.86,1.64a.22.22,0,0,1,.13.19.21.21,0,0,1-.13.19l-1,.58a.67.67,0,0,1-.33.08.68.68,0,0,1-.34-.08l-7.91-4.57c-.09,0-.14-.12-.13-.19a.21.21,0,0,1,.13-.19Zm2,3.29,1.78-1a2,2,0,0,0,.87-.79c.11-.25-.06-.51-.52-.78a2,2,0,0,0-1.33-.29,4,4,0,0,0-1.35.51l-1.77,1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,211.47a.72.72,0,0,1,.66,0l.87.5a.23.23,0,0,1,.14.19.22.22,0,0,1-.14.19l-5.38,3.11a.64.64,0,0,1-.33.08.67.67,0,0,1-.33-.08l-7.91-4.57a.23.23,0,0,1-.14-.19.22.22,0,0,1,.14-.19l5.28-3a.72.72,0,0,1,.66,0l.87.5a.23.23,0,0,1,.14.19.22.22,0,0,1-.14.19l-4,2.29,2,1.12,3.69-2.13a.81.81,0,0,1,.66,0l.87.51a.21.21,0,0,1,.13.19.22.22,0,0,1-.13.19l-3.69,2.13,2,1.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.61,204.57a6.65,6.65,0,0,1,1.66-.71,7.4,7.4,0,0,1,1.59-.28,5.44,5.44,0,0,1,1.36,0,3.6,3.6,0,0,1,1,.3c.1,0,.15.12.14.19a.24.24,0,0,1-.14.19l-.86.5a.94.94,0,0,1-.39.13,1.9,1.9,0,0,1-.41,0,4,4,0,0,0-1.09,0,3.91,3.91,0,0,0-1.33.51,2.35,2.35,0,0,0-.54.39,1.31,1.31,0,0,0-.31.4.51.51,0,0,0,0,.38.57.57,0,0,0,.29.31,1.6,1.6,0,0,0,.58.2,2.48,2.48,0,0,0,.69,0,7.07,7.07,0,0,0,1-.29l1.39-.5a14.28,14.28,0,0,1,1.64-.51,6.72,6.72,0,0,1,1.38-.21,4.62,4.62,0,0,1,1.2.11,4.19,4.19,0,0,1,1.06.42,2,2,0,0,1,.77.73,1.16,1.16,0,0,1,.12.87,2.27,2.27,0,0,1-.59,1,5.55,5.55,0,0,1-1.28,1,7.33,7.33,0,0,1-1.48.66,8.31,8.31,0,0,1-1.59.37,6,6,0,0,1-1.53,0,3.84,3.84,0,0,1-1.31-.37c-.1,0-.15-.12-.14-.19a.22.22,0,0,1,.14-.19l.86-.5a1,1,0,0,1,.39-.14,1.46,1.46,0,0,1,.41,0,3.92,3.92,0,0,0,.52.06,2.64,2.64,0,0,0,.62,0,4.64,4.64,0,0,0,1.57-.59,5,5,0,0,0,.66-.44,2.11,2.11,0,0,0,.42-.45.63.63,0,0,0,.09-.43.55.55,0,0,0-.31-.36,1.13,1.13,0,0,0-.61-.16,3.06,3.06,0,0,0-.82.13c-.31.09-.67.21-1.09.37l-1.47.52a12.84,12.84,0,0,1-1.42.42,5.69,5.69,0,0,1-1.26.15,4.81,4.81,0,0,1-1.14-.14,4.28,4.28,0,0,1-1.09-.47,2,2,0,0,1-.78-.72,1.27,1.27,0,0,1-.12-.85,2,2,0,0,1,.5-.89A4.15,4.15,0,0,1,102.61,204.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.48,202.52a.72.72,0,0,1,.66,0l.87.5c.09.06.14.12.13.2s0,.13-.13.19l-5.38,3.1a.72.72,0,0,1-.66,0l-7.91-4.57a.22.22,0,0,1-.14-.19.23.23,0,0,1,.14-.19l5.28-3.05a.72.72,0,0,1,.66,0l.87.5a.21.21,0,0,1,0,.39l-4,2.28,2,1.13,3.69-2.13a.72.72,0,0,1,.66,0l.87.5a.21.21,0,0,1,.13.19.22.22,0,0,1-.13.19l-3.69,2.13,2,1.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.32,195.06a.7.7,0,0,1,.39-.11,2,2,0,0,1,.49.08l10.74,2.74.1,0a.22.22,0,0,1,.13.19.21.21,0,0,1-.13.19l-.88.51a.89.89,0,0,1-.45.14,1.13,1.13,0,0,1-.34,0l-1.88-.48-3.88,2.24.84,1.09a.36.36,0,0,1,.07.19c0,.08-.08.16-.24.26l-.88.51a.74.74,0,0,1-.34.08.67.67,0,0,1-.33-.08l-.07-.06-4.74-6.2a.49.49,0,0,1-.14-.28c0-.08.06-.16.19-.23Zm6.05,2.72-4.84-1.24,2.14,2.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.4,190.39a6.42,6.42,0,0,1,3-.93,5.09,5.09,0,0,1,2.77.68,2.31,2.31,0,0,1,1.11,1.11,1.23,1.23,0,0,1-.27,1.24l4.72.77.17.06a.17.17,0,0,1,.11.16.16.16,0,0,1-.11.15l-1,.6a.88.88,0,0,1-.48.14l-.38,0-4.46-.73-1.63.95,2.86,1.64a.21.21,0,0,1,0,.39l-1,.57a.68.68,0,0,1-.34.08.7.7,0,0,1-.33-.08l-7.91-4.57a.22.22,0,0,1-.13-.19.21.21,0,0,1,.13-.19Zm2,3.29,1.78-1a2.13,2.13,0,0,0,.87-.79c.11-.25-.06-.51-.52-.78a2,2,0,0,0-1.33-.29,4,4,0,0,0-1.35.51l-1.77,1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.24,188c-.09-.07-.13-.14-.11-.21a.32.32,0,0,1,.15-.18l1-.57a.67.67,0,0,1,.33-.09.51.51,0,0,1,.33.09,2.91,2.91,0,0,1,.76.72,1.4,1.4,0,0,1,.25.9,2,2,0,0,1-.46,1,4.69,4.69,0,0,1-1.37,1.09,7.18,7.18,0,0,1-1.75.72,7.34,7.34,0,0,1-1.8.23,7.52,7.52,0,0,1-1.77-.21,8.21,8.21,0,0,1-1.66-.61c-.33-.17-.68-.37-1.06-.58s-.71-.42-1-.61a4,4,0,0,1-1.06-1,1.71,1.71,0,0,1-.37-1,1.79,1.79,0,0,1,.41-1,4.14,4.14,0,0,1,1.24-1,7.59,7.59,0,0,1,1.89-.8,8.23,8.23,0,0,1,1.77-.26,6.49,6.49,0,0,1,1.57.15,5.88,5.88,0,0,1,1.25.43c.11.05.16.12.15.19a.25.25,0,0,1-.15.19l-1,.58a.88.88,0,0,1-.31.08.64.64,0,0,1-.38-.06,2.79,2.79,0,0,0-.65-.17,3.31,3.31,0,0,0-.78,0,3.86,3.86,0,0,0-.89.17,4.55,4.55,0,0,0-1,.41,2,2,0,0,0-.68.57,1,1,0,0,0-.21.56,1,1,0,0,0,.22.56,2.55,2.55,0,0,0,.57.5l1,.61c.37.22.72.41,1.05.58a4.43,4.43,0,0,0,.88.33,4.35,4.35,0,0,0,1,.13,4.25,4.25,0,0,0,1-.12,3.43,3.43,0,0,0,1-.4,2.8,2.8,0,0,0,.72-.54,1.31,1.31,0,0,0,.29-.52.72.72,0,0,0,0-.46A1.08,1.08,0,0,0,143.24,188Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.17,179a.59.59,0,0,1,.34-.08.58.58,0,0,1,.33.08l7.91,4.56c.09.06.14.12.13.2s0,.14-.13.19l-1,.57a.72.72,0,0,1-.66,0l-3.24-1.87-3.7,2.14,3.24,1.87a.21.21,0,0,1,.13.19.22.22,0,0,1-.13.19l-1,.57a.72.72,0,0,1-.66,0L140.83,183a.22.22,0,0,1-.14-.19.23.23,0,0,1,.14-.19l1-.57a.72.72,0,0,1,.66,0l3.15,1.81,3.7-2.13-3.15-1.82a.2.2,0,0,1,0-.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.51 185.2 95.06 221.83 96.79 222.83 160.24 186.2 158.51 185.2",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.51 185.2 95.06 221.83 96.79 222.83 160.24 186.2 158.51 185.2",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.06 178.62 83.69 237.15 81.8 236.06 183.17 177.53 185.06 178.62",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.58 181.23 88.21 239.76 86.31 238.66 187.69 180.14 189.58 181.23",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.1 183.84 92.72 242.37 90.83 241.27 192.2 182.74 194.1 183.84",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.93 203.37 126.56 261.9 124.66 260.81 226.03 202.28 227.93 203.37",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.45 205.98 131.07 264.51 129.18 263.41 230.55 204.88 232.45 205.98",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.96 208.59 135.59 267.11 133.69 266.02 235.07 207.49 236.96 208.59",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.18 246.24 202.97 303.52 201.07 302.42 300.28 245.14 302.18 246.24",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.69 248.84 207.48 306.13 205.59 305.03 304.8 247.75 306.69 248.84",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.33 240.22 101.17 247.24 96.36 244.47 108.53 237.45 113.33 240.22",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.19 231.63 116.03 238.66 111.23 235.88 123.39 228.86 128.19 231.63",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.06 223.05 130.9 230.07 126.1 227.3 138.26 220.28 143.06 223.05",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.93 214.47 145.77 221.49 140.97 218.72 153.13 211.69 157.93 214.47",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.8 205.88 160.64 212.9 155.84 210.13 168 203.11 172.8 205.88",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.67 197.3 175.51 204.32 170.71 201.55 182.87 194.53 187.67 197.3",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "119.6 243.84 107.44 250.86 102.64 248.09 114.8 241.07 119.6 243.84",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.47 235.26 122.31 242.28 117.51 239.51 129.67 232.49 134.47 235.26",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.34 226.67 137.18 233.69 132.38 230.92 144.54 223.9 149.34 226.67",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.21 218.09 152.05 225.11 147.25 222.34 159.41 215.32 164.21 218.09",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.08 209.5 166.92 216.53 162.12 213.75 174.28 206.73 179.08 209.5",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.95 200.92 181.79 207.94 176.99 205.17 189.15 198.15 193.95 200.92",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.82 192.34 196.66 199.36 191.85 196.59 204.02 189.56 208.82 192.34",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.88 247.47 113.72 254.49 108.92 251.72 121.08 244.7 125.88 247.47",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.75 238.88 128.59 245.9 123.79 243.13 135.95 236.11 140.75 238.88",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.62 230.3 143.46 237.32 138.66 234.55 150.82 227.53 155.62 230.3",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.49 221.71 158.33 228.74 153.53 225.96 165.69 218.94 170.49 221.71",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.36 213.13 173.19 220.15 168.4 217.38 180.56 210.36 185.36 213.13",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.22 204.54 188.06 211.57 183.26 208.79 195.43 201.77 200.22 204.54",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.09 195.96 202.93 202.98 198.13 200.21 210.29 193.19 215.09 195.96",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.16 251.09 120 258.11 115.2 255.34 127.36 248.32 132.16 251.09",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.03 242.51 134.87 249.53 130.07 246.76 142.23 239.74 147.03 242.51",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.9 233.92 149.74 240.94 144.94 238.17 157.1 231.15 161.9 233.92",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.76 225.34 164.6 232.36 159.8 229.59 171.96 222.57 176.76 225.34",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.63 216.75 179.47 223.77 174.67 221 186.83 213.98 191.63 216.75",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.5 208.17 194.34 215.19 189.54 212.42 201.7 205.4 206.5 208.17",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.37 199.58 209.21 206.6 204.41 203.83 216.57 196.81 221.37 199.58",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.33 240.22 101.17 247.24 96.36 244.47 108.53 237.45 113.33 240.22",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.19 231.63 116.03 238.66 111.23 235.88 123.39 228.86 128.19 231.63",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.06 223.05 130.9 230.07 126.1 227.3 138.26 220.28 143.06 223.05",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.93 214.47 145.77 221.49 140.97 218.72 153.13 211.69 157.93 214.47",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.8 205.88 160.64 212.9 155.84 210.13 168 203.11 172.8 205.88",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.67 197.3 175.51 204.32 170.71 201.55 182.87 194.53 187.67 197.3",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.54 188.71 190.38 195.73 185.58 192.96 197.74 185.94 202.54 188.71",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "113.33 240.22 101.17 247.24 96.36 244.47 108.53 237.45 113.33 240.22",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.19 231.63 116.03 238.66 111.23 235.88 123.39 228.86 128.19 231.63",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.06 223.05 130.9 230.07 126.1 227.3 138.26 220.28 143.06 223.05",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.93 214.47 145.77 221.49 140.97 218.72 153.13 211.69 157.93 214.47",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.8 205.88 160.64 212.9 155.84 210.13 168 203.11 172.8 205.88",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.67 197.3 175.51 204.32 170.71 201.55 182.87 194.53 187.67 197.3",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.54 188.71 190.38 195.73 185.58 192.96 197.74 185.94 202.54 188.71",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M213.29,252.51l-22-12.71c9.05-5.16,23.62-6.18,35.34-2.72,14.48,4.28,21.38,15.06,14.4,23.57Z",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.29,252.51l-22-12.71c9.05-5.16,23.62-6.18,35.34-2.72,14.48,4.28,21.38,15.06,14.4,23.57Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M233.53,265.45a32.62,32.62,0,0,1-6.25,2.72L215.9,255.28l22.34,6.57A21.72,21.72,0,0,1,233.53,265.45Z",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M233.53,265.45a32.62,32.62,0,0,1-6.25,2.72L215.9,255.28l22.34,6.57A21.72,21.72,0,0,1,233.53,265.45Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M225.23,269.78a50.79,50.79,0,0,1-25.74,0l12.88-14.57Z",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.45,268.17a32.26,32.26,0,0,1-6.2-2.74c-11.27-6.51-11.63-17-1.06-23.74l20.29,11.72Z",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.45,268.17a32.26,32.26,0,0,1-6.2-2.74c-11.27-6.51-11.63-17-1.06-23.74l20.29,11.72Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M220.51,240.18a.2.2,0,0,1-.18-.1.2.2,0,0,1,.08-.29l1.48-.86a.21.21,0,1,1,.21.37l-1.48.86A.2.2,0,0,1,220.51,240.18Zm3-1.71a.23.23,0,0,1-.19-.1.23.23,0,0,1,.08-.3l1.48-.85a.22.22,0,1,1,.22.37l-1.48.85A.23.23,0,0,1,223.48,238.47Zm3-1.71a.21.21,0,0,1-.18-.11.21.21,0,0,1,.08-.29l1.48-.86a.22.22,0,0,1,.29.08.21.21,0,0,1-.08.3l-1.48.85A.2.2,0,0,1,226.44,236.76Zm3-1.71a.22.22,0,0,1-.11-.4l1.49-.86a.21.21,0,0,1,.21.37l-1.48.86A.23.23,0,0,1,229.41,235.05Zm3-1.71a.21.21,0,0,1-.11-.4l1.48-.86a.22.22,0,0,1,.22.37l-1.49.86A.19.19,0,0,1,232.38,233.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.78,264.84a.22.22,0,0,1-.11-.4l1.49-.86a.21.21,0,0,1,.21.37l-1.48.86A.23.23,0,0,1,174.78,264.84Zm3-1.72a.21.21,0,0,1-.19-.1.21.21,0,0,1,.08-.29l1.48-.86a.22.22,0,0,1,.22.37l-1.49.86A.18.18,0,0,1,177.75,263.12Zm3-1.71a.22.22,0,0,1-.18-.1.21.21,0,0,1,.08-.3l1.48-.85a.21.21,0,0,1,.29.07.22.22,0,0,1-.08.3l-1.48.85A.2.2,0,0,1,180.71,261.41Zm3-1.71a.21.21,0,0,1-.11-.4l1.48-.86a.22.22,0,0,1,.3.08.24.24,0,0,1-.08.3l-1.49.85A.19.19,0,0,1,183.68,259.7Zm3-1.71a.21.21,0,0,1-.18-.11.21.21,0,0,1,.08-.29l1.48-.86a.21.21,0,0,1,.29.08.21.21,0,0,1-.08.29l-1.48.86A.2.2,0,0,1,186.64,258Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.27,241.27c-.45-.26-.45-.67,0-.93a1.8,1.8,0,0,1,1.6,0,.49.49,0,0,1,0,.93A1.8,1.8,0,0,1,218.27,241.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.21,256.87a.49.49,0,0,1,0-.93,1.8,1.8,0,0,1,1.6,0,.49.49,0,0,1,0,.93A1.74,1.74,0,0,1,188.21,256.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.56,264.66a.48.48,0,0,1,0-.92,1.74,1.74,0,0,1,1.6,0,.49.49,0,0,1,0,.92A1.74,1.74,0,0,1,230.56,264.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.24,229.83a.29.29,0,0,1-.14,0,.33.33,0,0,1-.15,0l-.66-.38-1.69,1a.24.24,0,0,1-.15,0,.26.26,0,0,1-.15,0l-.38-.22s-.09-.06-.1-.1a.34.34,0,0,1,0-.12l-.41-2.16a.18.18,0,0,1,.08-.21l.42-.24.15,0,.14,0,2.18,1.26.47-.27a.3.3,0,0,1,.3,0l.38.22a.09.09,0,0,1,.07.09.12.12,0,0,1-.06.08L241,229l.66.38a.12.12,0,0,1,.06.09.09.09,0,0,1-.06.08Zm-1.63-.78-1.17-.67.24,1.21Z",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.49,226.6a.09.09,0,0,1-.06-.08.1.1,0,0,1,.06-.09l2-1.18a.3.3,0,0,1,.3,0l.39.22a.1.1,0,0,1,.06.09.09.09,0,0,1-.06.08l-1.54.89.64.43a.88.88,0,0,1,.22-.21l.23-.14a2.9,2.9,0,0,1,.65-.28,2.78,2.78,0,0,1,.69-.12,3.25,3.25,0,0,1,.7,0,2.57,2.57,0,0,1,.65.25,1.46,1.46,0,0,1,.48.41.6.6,0,0,1,.11.41.84.84,0,0,1-.22.4,2.51,2.51,0,0,1-.49.37,3.53,3.53,0,0,1-.73.32,3,3,0,0,1-.68.12,2.49,2.49,0,0,1-.62,0,2,2,0,0,1-.5-.18.09.09,0,0,1-.07-.09.13.13,0,0,1,.07-.08l.44-.25a.18.18,0,0,1,.13,0,.41.41,0,0,1,.16,0,1.13,1.13,0,0,0,.31.06l.29,0a1.14,1.14,0,0,0,.26-.09,2.1,2.1,0,0,0,.26-.13c.21-.12.32-.25.33-.38s-.07-.27-.27-.38a1,1,0,0,0-.6-.13,1.61,1.61,0,0,0-.67.19,1,1,0,0,0-.23.17.48.48,0,0,0-.1.12l0,.1a.38.38,0,0,1-.11.08l-.5.29a.23.23,0,0,1-.14,0,.24.24,0,0,1-.15,0Z",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.15,224.29a1.62,1.62,0,0,1,.41-.17,1.83,1.83,0,0,1,.4-.05,1.5,1.5,0,0,1,.37,0,1.25,1.25,0,0,1,.31.1l.32.17.29.18a1,1,0,0,1,.18.18.36.36,0,0,1,.07.22.5.5,0,0,1-.1.23.79.79,0,0,1-.29.23,1.32,1.32,0,0,1-.41.17,1.39,1.39,0,0,1-.4.06,1.5,1.5,0,0,1-.37,0,1.42,1.42,0,0,1-.31-.11l-.31-.17a2.45,2.45,0,0,1-.29-.18.66.66,0,0,1-.19-.18.27.27,0,0,1-.06-.21.37.37,0,0,1,.09-.23A.92.92,0,0,1,243.15,224.29Zm1.52.54-.1-.06-.15-.08-.14-.09-.11-.06a1.1,1.1,0,0,0-.26-.06.48.48,0,0,0-.29.08c-.11.06-.16.12-.15.17a.32.32,0,0,0,.12.15l.1.06.14.09.15.08.11.06a.58.58,0,0,0,.26.06.48.48,0,0,0,.29-.08c.11-.06.15-.12.14-.17A.24.24,0,0,0,244.67,224.83Zm.8-1.73a.14.14,0,0,1,0-.09.24.24,0,0,1,.09-.08l.33-.19.12,0,.12,0,0,0s0,0,0,0l.85,3.6a.14.14,0,0,1,0,.09.24.24,0,0,1-.09.08l-.33.19a.28.28,0,0,1-.12,0,.2.2,0,0,1-.11,0l0,0v0Zm1.95.93a1.78,1.78,0,0,1,.41-.17,2,2,0,0,1,.41-.05,1.5,1.5,0,0,1,.37,0,1.42,1.42,0,0,1,.31.11l.31.16.29.19a.79.79,0,0,1,.19.17.3.3,0,0,1,.06.22.4.4,0,0,1-.09.23,1.05,1.05,0,0,1-.29.24,1.74,1.74,0,0,1-.41.16,1.44,1.44,0,0,1-.4.06,1.5,1.5,0,0,1-.37,0,1.25,1.25,0,0,1-.31-.11l-.32-.16-.29-.19a.62.62,0,0,1-.18-.18.31.31,0,0,1-.07-.21.5.5,0,0,1,.1-.23A.87.87,0,0,1,247.42,224Zm1.53.55-.1-.07-.15-.08-.15-.09-.11-.05a.72.72,0,0,0-.25-.07.52.52,0,0,0-.3.08c-.1.06-.15.12-.14.17a.29.29,0,0,0,.11.15l.1.07.15.08.15.08.11.06a.72.72,0,0,0,.25.07.54.54,0,0,0,.3-.09c.1-.06.15-.11.14-.17A.24.24,0,0,0,249,224.58Z",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.24,229.83a.29.29,0,0,1-.14,0,.33.33,0,0,1-.15,0l-.66-.38-1.69,1a.24.24,0,0,1-.15,0,.26.26,0,0,1-.15,0l-.38-.22s-.09-.06-.1-.1a.34.34,0,0,1,0-.12l-.41-2.16a.18.18,0,0,1,.08-.21l.42-.24.15,0,.14,0,2.18,1.26.47-.27a.3.3,0,0,1,.3,0l.38.22a.09.09,0,0,1,.07.09.12.12,0,0,1-.06.08L241,229l.66.38a.12.12,0,0,1,.06.09.09.09,0,0,1-.06.08Zm-1.63-.78-1.17-.67.24,1.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.49,226.6a.09.09,0,0,1-.06-.08.1.1,0,0,1,.06-.09l2-1.18a.3.3,0,0,1,.3,0l.39.22a.1.1,0,0,1,.06.09.09.09,0,0,1-.06.08l-1.54.89.64.43a.88.88,0,0,1,.22-.21l.23-.14a2.9,2.9,0,0,1,.65-.28,2.78,2.78,0,0,1,.69-.12,3.25,3.25,0,0,1,.7,0,2.57,2.57,0,0,1,.65.25,1.46,1.46,0,0,1,.48.41.6.6,0,0,1,.11.41.84.84,0,0,1-.22.4,2.51,2.51,0,0,1-.49.37,3.53,3.53,0,0,1-.73.32,3,3,0,0,1-.68.12,2.49,2.49,0,0,1-.62,0,2,2,0,0,1-.5-.18.09.09,0,0,1-.07-.09.13.13,0,0,1,.07-.08l.44-.25a.18.18,0,0,1,.13,0,.41.41,0,0,1,.16,0,1.13,1.13,0,0,0,.31.06l.29,0a1.14,1.14,0,0,0,.26-.09,2.1,2.1,0,0,0,.26-.13c.21-.12.32-.25.33-.38s-.07-.27-.27-.38a1,1,0,0,0-.6-.13,1.61,1.61,0,0,0-.67.19,1,1,0,0,0-.23.17.48.48,0,0,0-.1.12l0,.1a.38.38,0,0,1-.11.08l-.5.29a.23.23,0,0,1-.14,0,.24.24,0,0,1-.15,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.15,224.29a1.62,1.62,0,0,1,.41-.17,1.83,1.83,0,0,1,.4-.05,1.5,1.5,0,0,1,.37,0,1.25,1.25,0,0,1,.31.1l.32.17.29.18a1,1,0,0,1,.18.18.36.36,0,0,1,.07.22.5.5,0,0,1-.1.23.79.79,0,0,1-.29.23,1.32,1.32,0,0,1-.41.17,1.39,1.39,0,0,1-.4.06,1.5,1.5,0,0,1-.37,0,1.42,1.42,0,0,1-.31-.11l-.31-.17a2.45,2.45,0,0,1-.29-.18.66.66,0,0,1-.19-.18.27.27,0,0,1-.06-.21.37.37,0,0,1,.09-.23A.92.92,0,0,1,243.15,224.29Zm1.52.54-.1-.06-.15-.08-.14-.09-.11-.06a1.1,1.1,0,0,0-.26-.06.48.48,0,0,0-.29.08c-.11.06-.16.12-.15.17a.32.32,0,0,0,.12.15l.1.06.14.09.15.08.11.06a.58.58,0,0,0,.26.06.48.48,0,0,0,.29-.08c.11-.06.15-.12.14-.17A.24.24,0,0,0,244.67,224.83Zm.8-1.73a.14.14,0,0,1,0-.09.24.24,0,0,1,.09-.08l.33-.19.12,0,.12,0,0,0s0,0,0,0l.85,3.6a.14.14,0,0,1,0,.09.24.24,0,0,1-.09.08l-.33.19a.28.28,0,0,1-.12,0,.2.2,0,0,1-.11,0l0,0v0Zm1.95.93a1.78,1.78,0,0,1,.41-.17,2,2,0,0,1,.41-.05,1.5,1.5,0,0,1,.37,0,1.42,1.42,0,0,1,.31.11l.31.16.29.19a.79.79,0,0,1,.19.17.3.3,0,0,1,.06.22.4.4,0,0,1-.09.23,1.05,1.05,0,0,1-.29.24,1.74,1.74,0,0,1-.41.16,1.44,1.44,0,0,1-.4.06,1.5,1.5,0,0,1-.37,0,1.25,1.25,0,0,1-.31-.11l-.32-.16-.29-.19a.62.62,0,0,1-.18-.18.31.31,0,0,1-.07-.21.5.5,0,0,1,.1-.23A.87.87,0,0,1,247.42,224Zm1.53.55-.1-.07-.15-.08-.15-.09-.11-.05a.72.72,0,0,0-.25-.07.52.52,0,0,0-.3.08c-.1.06-.15.12-.14.17a.29.29,0,0,0,.11.15l.1.07.15.08.15.08.11.06a.72.72,0,0,0,.25.07.54.54,0,0,0,.3-.09c.1-.06.15-.11.14-.17A.24.24,0,0,0,249,224.58Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M241.63,234.48l.07,0,.07,0,.18.11s0,0,0,0a.05.05,0,0,1,0,0l-1.14.66h-.14l-1.68-1s0,0,0,0,0,0,0,0l.21-.12h.14l1.43.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,233.88a1.08,1.08,0,0,1-.22-.19.37.37,0,0,1-.08-.21.43.43,0,0,1,.08-.23,1,1,0,0,1,.28-.22,1.61,1.61,0,0,1,.39-.16,1.58,1.58,0,0,1,.38-.05,1.5,1.5,0,0,1,.37.05,1.85,1.85,0,0,1,.33.12l.11.06.13.07.12.08.1.06a.86.86,0,0,1,.22.19.31.31,0,0,1,.08.21.36.36,0,0,1-.08.23,1,1,0,0,1-.28.22,1.61,1.61,0,0,1-.39.16,1.65,1.65,0,0,1-.38,0,1.42,1.42,0,0,1-.36,0,1.61,1.61,0,0,1-.33-.12l-.12-.07-.12-.07a.35.35,0,0,1-.12-.07Zm1.19-.68a.85.85,0,0,0-.41-.09.83.83,0,0,0-.4.11c-.12.07-.18.14-.18.22s0,.17.16.24l.22.13.22.13a.87.87,0,0,0,.41.09.8.8,0,0,0,.4-.11c.12-.07.18-.14.19-.23a.28.28,0,0,0-.17-.23,1.42,1.42,0,0,0-.22-.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,232a1.23,1.23,0,0,1,.64-.2,1.1,1.1,0,0,1,.59.14.52.52,0,0,1,.23.24.24.24,0,0,1-.05.26l1,.17h0l0,0s0,0,0,0l-.22.13a.19.19,0,0,1-.1,0H245l-1-.16-.34.2.6.35a.05.05,0,0,1,0,0s0,0,0,0l-.21.12a.08.08,0,0,1-.07,0,.1.1,0,0,1-.07,0l-1.68-1s0,0,0,0a0,0,0,0,1,0,0Zm.42.69.38-.21a.54.54,0,0,0,.19-.17s0-.11-.11-.17a.52.52,0,0,0-.29-.06.9.9,0,0,0-.28.11l-.38.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.68,231.56h.14l.19.11s0,0,0,0,0,0,0,0l-1.15.66a.06.06,0,0,1-.06,0,.08.08,0,0,1-.07,0l-1.68-1a.05.05,0,0,1,0,0s0,0,0,0l1.12-.65.07,0,.07,0,.18.11s0,0,0,0a.05.05,0,0,1,0,0l-.84.48.42.24.78-.45.07,0,.07,0,.18.11s0,0,0,0a.05.05,0,0,1,0,0l-.78.45.43.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.36,230.52l-.36-.79a.1.1,0,0,1,0,0s0,0,0-.06l.18-.1.07,0,.07,0,1.67,1s0,0,0,0a.05.05,0,0,1,0,0l-.21.12-.07,0-.07,0-1-.59.25.54v0a.05.05,0,0,1,0,.05l-.13.08-.08,0h-.08l-.93-.15,1,.59s0,0,0,0,0,0,0,0l-.21.12-.07,0-.07,0-1.68-1s0,0,0,0a.05.05,0,0,1,0,0l.18-.1a.19.19,0,0,1,.1,0H246Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.17,229.92l-.07,0-.07,0-1.68-1a.05.05,0,0,1,0,0,.05.05,0,0,1,0,0l.21-.12.07,0,.06,0,1.68,1s0,0,0,0a.05.05,0,0,1,0,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.81,228a1.41,1.41,0,0,1,.63-.2,1.09,1.09,0,0,1,.61.15q.28.17.27.36c0,.12-.13.25-.34.37l-.42.24.58.33a.05.05,0,0,1,0,0s0,0,0,0l-.21.12a.13.13,0,0,1-.14,0l-1.68-1s0,0,0,0a.05.05,0,0,1,0,0Zm.43.73.4-.23a.42.42,0,0,0,.18-.17c0-.06,0-.12-.12-.17a.43.43,0,0,0-.29-.07.75.75,0,0,0-.29.11l-.4.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.35,227.11a1.38,1.38,0,0,1,.36-.15l.33-.06a1.36,1.36,0,0,1,.29,0l.21.06s0,0,0,.05l0,0-.18.1-.08,0H252a.71.71,0,0,0-.28.11.36.36,0,0,0-.12.08.24.24,0,0,0-.06.09.09.09,0,0,0,0,.07.12.12,0,0,0,.07.07.21.21,0,0,0,.12,0,.4.4,0,0,0,.15,0l.2-.06.29-.1a2.28,2.28,0,0,1,.35-.11,1.87,1.87,0,0,1,.3-.05,1,1,0,0,1,.25,0,.47.47,0,0,1,.22.09.36.36,0,0,1,.17.15.25.25,0,0,1,0,.19.39.39,0,0,1-.12.2,1.18,1.18,0,0,1-.27.2,1.15,1.15,0,0,1-.32.14,1.32,1.32,0,0,1-.33.08,1.22,1.22,0,0,1-.33,0,.69.69,0,0,1-.28-.08s0,0,0,0a.05.05,0,0,1,0,0l.19-.1a.11.11,0,0,1,.08,0,.22.22,0,0,1,.08,0l.12,0h.13l.15,0,.18-.08.14-.1a.38.38,0,0,0,.09-.09.18.18,0,0,0,0-.09s0-.06-.07-.08a.25.25,0,0,0-.13,0l-.17,0-.23.08-.31.11-.31.09-.26,0a.88.88,0,0,1-.24,0,.82.82,0,0,1-.24-.1.34.34,0,0,1-.16-.15.29.29,0,0,1,0-.18.47.47,0,0,1,.11-.19A1.15,1.15,0,0,1,251.35,227.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.85,225.7l.07,0,.07,0,1.06.62a.86.86,0,0,1,.25.19.37.37,0,0,1,.08.21.35.35,0,0,1-.09.22,1.06,1.06,0,0,1-.27.22,2.05,2.05,0,0,1-.38.16,1.65,1.65,0,0,1-.38.05,1.49,1.49,0,0,1-.36-.05,2,2,0,0,1-.34-.14l-1.06-.62s0,0,0,0,0,0,0,0l.21-.12.07,0,.07,0,1.05.61a.6.6,0,0,0,.21.08l.2,0a.64.64,0,0,0,.2,0l.18-.08a.53.53,0,0,0,.14-.11.16.16,0,0,0,0-.11.15.15,0,0,0,0-.12.49.49,0,0,0-.15-.12l-1.05-.61s0,0,0,0,0,0,0,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.09,225.48l-.37-.78v0s0,0,.05-.06l.17-.1.07,0,.07,0,1.68,1s0,0,0,0,0,0,0,0l-.21.12-.07,0-.07,0-1-.59.24.54a.06.06,0,0,1,0,0,.05.05,0,0,1,0,0l-.13.08-.09,0h-.07l-.93-.15,1,.59s0,0,0,0,0,0,0,0l-.21.12-.07,0-.07,0-1.68-1s0,0,0,0a.05.05,0,0,1,0,0l.18-.1a.17.17,0,0,1,.1,0h.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.75,269.84a.39.39,0,0,1,.3,0l.38.23a.14.14,0,0,1,.08.09s0,.06,0,.09l0,.95a2.84,2.84,0,0,1,.56-.19,3.7,3.7,0,0,1,.57-.07,2.51,2.51,0,0,1,.55.07,1.81,1.81,0,0,1,.5.2,1,1,0,0,1,.39.36.5.5,0,0,1,.07.39.88.88,0,0,1-.24.41,2.11,2.11,0,0,1-.5.38,3.31,3.31,0,0,1-.76.33,3.1,3.1,0,0,1-.7.14,2.35,2.35,0,0,1-.6,0,1.64,1.64,0,0,1-.47-.14c-.05,0-.07-.05-.07-.08s0-.06.07-.09l.43-.25a.24.24,0,0,1,.12,0l.18,0,.21,0,.25,0a1.35,1.35,0,0,0,.3-.08,3,3,0,0,0,.36-.18.88.88,0,0,0,.4-.39q.07-.2-.18-.33a.73.73,0,0,0-.55-.09,2,2,0,0,0-.64.25l-.46.26a.33.33,0,0,1-.15,0,.33.33,0,0,1-.14,0l-.39-.22a.13.13,0,0,1-.07-.09.38.38,0,0,1,0-.1l0-.9-1.5.87a.39.39,0,0,1-.3,0l-.39-.23a.09.09,0,0,1-.06-.08s0-.06.06-.09Z",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,268.47l.23.13.26.15.25.15a2.36,2.36,0,0,1,.23.13,2.57,2.57,0,0,1,.49.4.73.73,0,0,1,.22.41.61.61,0,0,1-.14.44,1.82,1.82,0,0,1-.56.45,2.78,2.78,0,0,1-.79.33,2.82,2.82,0,0,1-.75.08,3,3,0,0,1-.73-.13,4.88,4.88,0,0,1-.68-.28l-.48-.27c-.17-.1-.33-.19-.46-.28a2.65,2.65,0,0,1-.5-.4.72.72,0,0,1-.22-.42.63.63,0,0,1,.12-.44,1.71,1.71,0,0,1,.56-.45,2.78,2.78,0,0,1,.79-.33,2.85,2.85,0,0,1,.76-.08,2.6,2.6,0,0,1,.72.13A4.43,4.43,0,0,1,165,268.47Zm-1.26,1.82a2.2,2.2,0,0,0,.8.24,1.29,1.29,0,0,0,.76-.19c.25-.15.36-.29.33-.44a1,1,0,0,0-.42-.46l-.45-.27-.47-.26a2.2,2.2,0,0,0-.8-.24,1.29,1.29,0,0,0-.76.19c-.25.15-.36.29-.32.44a.86.86,0,0,0,.42.46l.44.27Z",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.88,266.85a1.29,1.29,0,0,1,.41-.16,1.94,1.94,0,0,1,.4-.06,1.45,1.45,0,0,1,.37,0,1.25,1.25,0,0,1,.31.11,2.48,2.48,0,0,1,.32.17l.29.18a.62.62,0,0,1,.18.18.31.31,0,0,1,.07.21.39.39,0,0,1-.1.23.92.92,0,0,1-.29.24,1.67,1.67,0,0,1-.4.16,1.44,1.44,0,0,1-.4.06,1.53,1.53,0,0,1-.38,0,1.41,1.41,0,0,1-.31-.1l-.31-.17-.29-.18a1.11,1.11,0,0,1-.19-.18.35.35,0,0,1-.06-.22.4.4,0,0,1,.09-.23A.92.92,0,0,1,164.88,266.85Zm1.52.55-.1-.07-.15-.08-.14-.09-.11-.05a.77.77,0,0,0-.26-.07.55.55,0,0,0-.29.08c-.11.07-.16.12-.14.17a.23.23,0,0,0,.11.15l.1.07.14.08.15.09.11.05a.77.77,0,0,0,.26.07.55.55,0,0,0,.29-.08c.11-.07.16-.12.15-.17A.25.25,0,0,0,166.4,267.4Zm.8-1.73a.14.14,0,0,1,0-.09.19.19,0,0,1,.09-.09l.33-.19a.27.27,0,0,1,.12,0,.16.16,0,0,1,.12,0l0,0,0,0,.85,3.6a.28.28,0,0,1,0,.09s0,.05-.09.08l-.32.19a.22.22,0,0,1-.13,0l-.11,0,0,0v0Zm2,.92a1.92,1.92,0,0,1,.41-.16,2,2,0,0,1,.41-.06,2.21,2.21,0,0,1,.37,0l.31.11.31.17a2.45,2.45,0,0,1,.29.18.66.66,0,0,1,.19.18.35.35,0,0,1,.07.21.43.43,0,0,1-.1.23,1.05,1.05,0,0,1-.29.24,1.78,1.78,0,0,1-.41.17,1.83,1.83,0,0,1-.4.05,1.5,1.5,0,0,1-.37,0,1.25,1.25,0,0,1-.31-.1l-.31-.17-.3-.18a1,1,0,0,1-.18-.18.36.36,0,0,1-.07-.22.5.5,0,0,1,.1-.23A.87.87,0,0,1,169.15,266.59Zm1.53.55-.1-.06-.15-.09-.15-.08-.11-.06a.72.72,0,0,0-.25-.07.64.64,0,0,0-.3.09c-.1.06-.15.11-.14.17a.22.22,0,0,0,.12.14s.05,0,.09.07l.15.08.15.09.11.05a.77.77,0,0,0,.26.07.51.51,0,0,0,.29-.08c.1-.06.15-.12.14-.17A.26.26,0,0,0,170.68,267.14Z",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.75,269.84a.39.39,0,0,1,.3,0l.38.23a.14.14,0,0,1,.08.09s0,.06,0,.09l0,.95a2.84,2.84,0,0,1,.56-.19,3.7,3.7,0,0,1,.57-.07,2.51,2.51,0,0,1,.55.07,1.81,1.81,0,0,1,.5.2,1,1,0,0,1,.39.36.5.5,0,0,1,.07.39.88.88,0,0,1-.24.41,2.11,2.11,0,0,1-.5.38,3.31,3.31,0,0,1-.76.33,3.1,3.1,0,0,1-.7.14,2.35,2.35,0,0,1-.6,0,1.64,1.64,0,0,1-.47-.14c-.05,0-.07-.05-.07-.08s0-.06.07-.09l.43-.25a.24.24,0,0,1,.12,0l.18,0,.21,0,.25,0a1.35,1.35,0,0,0,.3-.08,3,3,0,0,0,.36-.18.88.88,0,0,0,.4-.39q.07-.2-.18-.33a.73.73,0,0,0-.55-.09,2,2,0,0,0-.64.25l-.46.26a.33.33,0,0,1-.15,0,.33.33,0,0,1-.14,0l-.39-.22a.13.13,0,0,1-.07-.09.38.38,0,0,1,0-.1l0-.9-1.5.87a.39.39,0,0,1-.3,0l-.39-.23a.09.09,0,0,1-.06-.08s0-.06.06-.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,268.47l.23.13.26.15.25.15a2.36,2.36,0,0,1,.23.13,2.57,2.57,0,0,1,.49.4.73.73,0,0,1,.22.41.61.61,0,0,1-.14.44,1.82,1.82,0,0,1-.56.45,2.78,2.78,0,0,1-.79.33,2.82,2.82,0,0,1-.75.08,3,3,0,0,1-.73-.13,4.88,4.88,0,0,1-.68-.28l-.48-.27c-.17-.1-.33-.19-.46-.28a2.65,2.65,0,0,1-.5-.4.72.72,0,0,1-.22-.42.63.63,0,0,1,.12-.44,1.71,1.71,0,0,1,.56-.45,2.78,2.78,0,0,1,.79-.33,2.85,2.85,0,0,1,.76-.08,2.6,2.6,0,0,1,.72.13A4.43,4.43,0,0,1,165,268.47Zm-1.26,1.82a2.2,2.2,0,0,0,.8.24,1.29,1.29,0,0,0,.76-.19c.25-.15.36-.29.33-.44a1,1,0,0,0-.42-.46l-.45-.27-.47-.26a2.2,2.2,0,0,0-.8-.24,1.29,1.29,0,0,0-.76.19c-.25.15-.36.29-.32.44a.86.86,0,0,0,.42.46l.44.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.88,266.85a1.29,1.29,0,0,1,.41-.16,1.94,1.94,0,0,1,.4-.06,1.45,1.45,0,0,1,.37,0,1.25,1.25,0,0,1,.31.11,2.48,2.48,0,0,1,.32.17l.29.18a.62.62,0,0,1,.18.18.31.31,0,0,1,.07.21.39.39,0,0,1-.1.23.92.92,0,0,1-.29.24,1.67,1.67,0,0,1-.4.16,1.44,1.44,0,0,1-.4.06,1.53,1.53,0,0,1-.38,0,1.41,1.41,0,0,1-.31-.1l-.31-.17-.29-.18a1.11,1.11,0,0,1-.19-.18.35.35,0,0,1-.06-.22.4.4,0,0,1,.09-.23A.92.92,0,0,1,164.88,266.85Zm1.52.55-.1-.07-.15-.08-.14-.09-.11-.05a.77.77,0,0,0-.26-.07.55.55,0,0,0-.29.08c-.11.07-.16.12-.14.17a.23.23,0,0,0,.11.15l.1.07.14.08.15.09.11.05a.77.77,0,0,0,.26.07.55.55,0,0,0,.29-.08c.11-.07.16-.12.15-.17A.25.25,0,0,0,166.4,267.4Zm.8-1.73a.14.14,0,0,1,0-.09.19.19,0,0,1,.09-.09l.33-.19a.27.27,0,0,1,.12,0,.16.16,0,0,1,.12,0l0,0,0,0,.85,3.6a.28.28,0,0,1,0,.09s0,.05-.09.08l-.32.19a.22.22,0,0,1-.13,0l-.11,0,0,0v0Zm2,.92a1.92,1.92,0,0,1,.41-.16,2,2,0,0,1,.41-.06,2.21,2.21,0,0,1,.37,0l.31.11.31.17a2.45,2.45,0,0,1,.29.18.66.66,0,0,1,.19.18.35.35,0,0,1,.07.21.43.43,0,0,1-.1.23,1.05,1.05,0,0,1-.29.24,1.78,1.78,0,0,1-.41.17,1.83,1.83,0,0,1-.4.05,1.5,1.5,0,0,1-.37,0,1.25,1.25,0,0,1-.31-.1l-.31-.17-.3-.18a1,1,0,0,1-.18-.18.36.36,0,0,1-.07-.22.5.5,0,0,1,.1-.23A.87.87,0,0,1,169.15,266.59Zm1.53.55-.1-.06-.15-.09-.15-.08-.11-.06a.72.72,0,0,0-.25-.07.64.64,0,0,0-.3.09c-.1.06-.15.11-.14.17a.22.22,0,0,0,.12.14s.05,0,.09.07l.15.08.15.09.11.05a.77.77,0,0,0,.26.07.51.51,0,0,0,.29-.08c.1-.06.15-.12.14-.17A.26.26,0,0,0,170.68,267.14Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M163.28,277.09l.07,0,.07,0,.18.11s0,0,0,0a.05.05,0,0,1,0,0l-1.14.66h-.14l-1.68-1,0,0s0,0,0,0l.21-.13H161l1.43.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.69,276.49a1.08,1.08,0,0,1-.22-.19.37.37,0,0,1-.08-.21.43.43,0,0,1,.08-.23,1,1,0,0,1,.28-.22,1.54,1.54,0,0,1,.38-.16,1.74,1.74,0,0,1,.39-.05,1.5,1.5,0,0,1,.37.05,2.19,2.19,0,0,1,.33.12l.11.06.13.08.12.07.1.06a.86.86,0,0,1,.22.19.37.37,0,0,1,.08.21.31.31,0,0,1-.08.23,1,1,0,0,1-.28.22,1.61,1.61,0,0,1-.39.16,1.65,1.65,0,0,1-.38.05,1.42,1.42,0,0,1-.36-.05,2,2,0,0,1-.34-.12l-.11-.07-.12-.07-.13-.07Zm1.19-.67a.76.76,0,0,0-.41-.1.8.8,0,0,0-.4.11c-.12.07-.18.14-.19.23a.3.3,0,0,0,.17.23l.22.13.22.13a.85.85,0,0,0,.41.09.8.8,0,0,0,.4-.11c.12-.07.18-.14.19-.22a.28.28,0,0,0-.17-.24l-.21-.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.62,274.59a1.4,1.4,0,0,1,.65-.2,1.1,1.1,0,0,1,.59.14.52.52,0,0,1,.23.24.26.26,0,0,1-.05.26l1,.17h0l0,0a0,0,0,0,1,0,0l-.22.13a.19.19,0,0,1-.1,0h-.08l-.95-.16-.34.2.6.35a.05.05,0,0,1,0,0s0,0,0,0l-.21.12a.08.08,0,0,1-.07,0,.1.1,0,0,1-.07,0l-1.68-1s0,0,0-.05a.05.05,0,0,1,0,0Zm.43.69.38-.21a.42.42,0,0,0,.18-.17s0-.11-.1-.17a.52.52,0,0,0-.29-.06,1.08,1.08,0,0,0-.28.11l-.38.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.33,274.17h.14l.19.11s0,0,0,0,0,0,0,0l-1.14.66-.08,0-.07,0-1.67-1a.05.05,0,0,1,0,0,.05.05,0,0,1,0,0l1.13-.65a.08.08,0,0,1,.07,0H167l.18.11s0,0,0,0a.05.05,0,0,1,0,0l-.84.48.41.24.79-.45.07,0,.07,0,.18.11s0,0,0,0a.05.05,0,0,1,0,0l-.78.45.43.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,273.13l-.36-.78a.43.43,0,0,1,0-.05s0,0,.05-.06l.17-.1.08,0,.07,0,1.67,1s0,0,0,0a.05.05,0,0,1,0,0l-.21.12-.07,0-.07,0-1-.59.25.54v0a.05.05,0,0,1,0,.05l-.13.08-.08,0h-.08l-.93-.15,1,.59s0,0,0,0,0,0,0,0l-.21.12-.07,0-.07,0-1.68-1s0,0,0,0a.05.05,0,0,1,0,0l.18-.1a.19.19,0,0,1,.1,0h.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.82,272.53l-.07,0-.07,0-1.68-1a.05.05,0,0,1,0,0l0,0,.21-.12.07,0,.08,0,1.67,1s0,0,0,0,0,0,0,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.46,270.64a1.41,1.41,0,0,1,.63-.2,1.09,1.09,0,0,1,.61.16c.19.11.28.22.26.35s-.12.25-.33.37l-.42.24.58.33a.05.05,0,0,1,0,0s0,0,0,0l-.21.12a.13.13,0,0,1-.14,0l-1.68-1s0,0,0-.05l0,0Zm.43.73.4-.23a.42.42,0,0,0,.18-.17c0-.06,0-.12-.12-.17a.45.45,0,0,0-.29-.07.69.69,0,0,0-.29.11l-.4.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,269.72a1.38,1.38,0,0,1,.36-.15l.33-.06a1.36,1.36,0,0,1,.29,0l.21.06s0,0,0,.05l0,0-.18.1-.08,0h-.32a.77.77,0,0,0-.28.11.36.36,0,0,0-.12.08.24.24,0,0,0-.06.09.09.09,0,0,0,0,.07.13.13,0,0,0,.06.07.28.28,0,0,0,.13,0,.27.27,0,0,0,.15,0l.2-.06.29-.1a2.28,2.28,0,0,1,.35-.11,1.87,1.87,0,0,1,.3-.05,1,1,0,0,1,.25,0,.6.6,0,0,1,.22.09.36.36,0,0,1,.17.15.25.25,0,0,1,0,.19.39.39,0,0,1-.12.2,1.18,1.18,0,0,1-.27.2,1.15,1.15,0,0,1-.32.14,1.32,1.32,0,0,1-.33.08,1.22,1.22,0,0,1-.33,0,.69.69,0,0,1-.28-.08s0,0,0,0a.05.05,0,0,1,0,0l.19-.1a.11.11,0,0,1,.08,0H174l.12,0h.13l.15,0,.18-.09a.67.67,0,0,0,.14-.09.38.38,0,0,0,.09-.09.18.18,0,0,0,0-.09s0-.06-.07-.08a.28.28,0,0,0-.13,0,.59.59,0,0,0-.17,0l-.23.08-.31.11-.31.09-.26,0a.88.88,0,0,1-.24,0,.82.82,0,0,1-.24-.1.39.39,0,0,1-.16-.15.29.29,0,0,1,0-.18.47.47,0,0,1,.11-.19A1.15,1.15,0,0,1,173,269.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.5,268.31l.07,0,.07,0,1.06.62a.86.86,0,0,1,.25.19.37.37,0,0,1,.08.21.35.35,0,0,1-.09.22,1.06,1.06,0,0,1-.27.22,2.39,2.39,0,0,1-.38.16,1.65,1.65,0,0,1-.38.05,1.49,1.49,0,0,1-.36-.05,1.43,1.43,0,0,1-.34-.14l-1.06-.62s0,0,0,0,0,0,0,0l.21-.12.07,0,.07,0,1.05.61a.6.6,0,0,0,.21.08l.2,0a.64.64,0,0,0,.2,0l.18-.08a.53.53,0,0,0,.14-.11.16.16,0,0,0,.05-.11.15.15,0,0,0,0-.12.49.49,0,0,0-.15-.12l-1.05-.61s0,0,0,0,0,0,0,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.74,268.09l-.36-.78a.07.07,0,0,1,0-.05s0,0,0-.06l.17-.1.07,0,.07,0,1.68,1s0,0,0,0,0,0,0,0l-.21.12-.07,0-.07,0-1-.59.24.54a.06.06,0,0,1,0,0,.05.05,0,0,1,0,.05l-.13.08-.09,0H178l-.93-.15,1,.59a.05.05,0,0,1,0,0s0,0,0,0l-.21.12-.07,0a.08.08,0,0,1-.07,0l-1.68-1s0,0,0,0a.05.05,0,0,1,0,0l.18-.1a.17.17,0,0,1,.1,0h.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.65,280.61a.23.23,0,0,1-.19-.1.22.22,0,0,1,.08-.3l1.48-.85a.21.21,0,0,1,.29.07.22.22,0,0,1-.07.3l-1.49.85A.19.19,0,0,1,207.65,280.61Zm3-1.71a.22.22,0,0,1-.11-.4l1.49-.86a.22.22,0,0,1,.29.08.23.23,0,0,1-.08.3l-1.48.85A.23.23,0,0,1,210.61,278.9Zm3-1.71a.21.21,0,0,1-.11-.4l1.48-.86a.22.22,0,0,1,.22.37l-1.49.86A.19.19,0,0,1,213.58,277.19Zm3-1.71a.21.21,0,0,1-.18-.11.21.21,0,0,1,.08-.29l1.48-.86a.21.21,0,1,1,.21.37l-1.48.86A.2.2,0,0,1,216.54,275.48Zm3-1.72a.21.21,0,0,1-.19-.1.22.22,0,0,1,.08-.3l.08,0-.77-.44a.21.21,0,0,1-.07-.29.2.2,0,0,1,.29-.08l1.4.81-.71.41Zm-2.17-1.71a.23.23,0,0,1-.11,0l-1.48-.85a.22.22,0,0,1-.08-.3.21.21,0,0,1,.29-.07l1.49.85a.22.22,0,0,1-.11.4Zm-3-1.71a.19.19,0,0,1-.1,0l-1.49-.86a.22.22,0,0,1-.08-.29.23.23,0,0,1,.3-.08l1.48.86a.21.21,0,0,1-.11.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.09,269.16a.49.49,0,0,1,0-.93,1.82,1.82,0,0,1,1.61,0,.49.49,0,0,1,0,.93A1.82,1.82,0,0,1,211.09,269.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.25,285.67a.39.39,0,0,1,.3,0l.39.23a.18.18,0,0,1,.07.08s0,.07,0,.1l0,.94a3,3,0,0,1,.56-.18,2.86,2.86,0,0,1,.57-.07,2,2,0,0,1,.55.07,1.69,1.69,0,0,1,.5.2,1,1,0,0,1,.39.35.52.52,0,0,1,.07.4.93.93,0,0,1-.24.41,2.11,2.11,0,0,1-.5.38,3.44,3.44,0,0,1-.75.33,3.94,3.94,0,0,1-.7.14,2.41,2.41,0,0,1-.61,0,1.75,1.75,0,0,1-.47-.14c-.05,0-.07-.05-.07-.08a.13.13,0,0,1,.07-.09l.43-.25a.24.24,0,0,1,.12,0h.18a1.18,1.18,0,0,0,.21,0l.25,0a1,1,0,0,0,.3-.09,2.84,2.84,0,0,0,.36-.17.88.88,0,0,0,.4-.39c0-.13,0-.24-.17-.34a.82.82,0,0,0-.56-.08,2,2,0,0,0-.64.25l-.46.26a.32.32,0,0,1-.14,0,.33.33,0,0,1-.15,0l-.39-.23a.13.13,0,0,1-.07-.08.38.38,0,0,1,0-.1l0-.9-1.5.86a.3.3,0,0,1-.3,0l-.39-.22a.09.09,0,0,1-.06-.08.1.1,0,0,1,.06-.09Z",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.48,284.3l.23.13.26.15.26.14.22.14a3,3,0,0,1,.49.39.78.78,0,0,1,.22.42.61.61,0,0,1-.14.44,1.84,1.84,0,0,1-.56.45,3.5,3.5,0,0,1-.79.33,2.8,2.8,0,0,1-.75.07,2.85,2.85,0,0,1-.72-.12,4.09,4.09,0,0,1-.68-.29l-.49-.26-.46-.28a3,3,0,0,1-.5-.4.75.75,0,0,1-.22-.42.63.63,0,0,1,.12-.44,1.85,1.85,0,0,1,.56-.46,3.05,3.05,0,0,1,.79-.32,2.49,2.49,0,0,1,.76-.08,2.6,2.6,0,0,1,.72.13A3.61,3.61,0,0,1,194.48,284.3Zm-1.26,1.81a2.2,2.2,0,0,0,.8.24,1.27,1.27,0,0,0,.76-.18c.25-.15.36-.3.33-.44a.92.92,0,0,0-.42-.46c-.14-.09-.28-.18-.45-.27l-.47-.26a2.2,2.2,0,0,0-.8-.24,1.29,1.29,0,0,0-.76.19c-.25.14-.36.29-.32.43s.17.3.42.46a4.45,4.45,0,0,0,.45.27Z",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.38,282.68a1.62,1.62,0,0,1,.41-.17,1.9,1.9,0,0,1,.4-.05,1.45,1.45,0,0,1,.37,0,1.5,1.5,0,0,1,.32.1l.31.17.29.18a1.11,1.11,0,0,1,.19.18.35.35,0,0,1,.06.22.48.48,0,0,1-.09.23.84.84,0,0,1-.3.23,1.38,1.38,0,0,1-.4.17,1.52,1.52,0,0,1-.77,0,1.51,1.51,0,0,1-.32-.11l-.31-.17-.29-.18a.66.66,0,0,1-.19-.18.31.31,0,0,1-.06-.21.37.37,0,0,1,.09-.23A1.05,1.05,0,0,1,194.38,282.68Zm1.52.55-.1-.07-.14-.08-.15-.09-.11-.05a.71.71,0,0,0-.26-.07.48.48,0,0,0-.29.08c-.11.06-.15.12-.14.17a.29.29,0,0,0,.11.15l.1.06.14.09.15.08.11.06a.58.58,0,0,0,.26.06.48.48,0,0,0,.29-.08c.11-.06.16-.11.15-.17A.22.22,0,0,0,195.9,283.23Zm.8-1.74a.14.14,0,0,1,0-.09.24.24,0,0,1,.09-.08l.33-.19.12,0a.24.24,0,0,1,.12,0l0,0,0,0,.85,3.6a.28.28,0,0,1,0,.09s0,.05-.09.08l-.32.19a.33.33,0,0,1-.13,0,.2.2,0,0,1-.11,0l0,0,0,0Zm2,.93a1.62,1.62,0,0,1,.41-.17,1.83,1.83,0,0,1,.4-.05,1.5,1.5,0,0,1,.37,0,1.25,1.25,0,0,1,.31.11l.31.16.3.19a.77.77,0,0,1,.18.18.31.31,0,0,1,.07.21.46.46,0,0,1-.1.23,1.05,1.05,0,0,1-.29.24,1.59,1.59,0,0,1-.41.16,1.39,1.39,0,0,1-.4.06,1.5,1.5,0,0,1-.37,0,1.42,1.42,0,0,1-.31-.11l-.31-.16-.29-.19a.66.66,0,0,1-.19-.18.31.31,0,0,1-.07-.21.5.5,0,0,1,.1-.23A.92.92,0,0,1,198.66,282.42Zm1.52.55-.1-.07-.15-.08-.15-.09-.1-.05a.77.77,0,0,0-.26-.07.48.48,0,0,0-.29.08c-.11.06-.16.12-.15.17s.05.1.12.15l.09.07.15.08.15.09.11.05a.77.77,0,0,0,.26.07.49.49,0,0,0,.29-.09c.11-.06.15-.11.14-.17A.24.24,0,0,0,200.18,283Z",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.78,292.92l.07,0,.07,0,.19.11s0,0,0,0,0,0,0,0l-1.14.66h-.14l-1.68-1s0,0,0-.05l0,0,.21-.12h.14l1.42.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.19,292.32a1,1,0,0,1-.21-.19.33.33,0,0,1-.09-.22.37.37,0,0,1,.09-.22.8.8,0,0,1,.27-.22,1.61,1.61,0,0,1,.39-.16,1.73,1.73,0,0,1,.38-.05,1.5,1.5,0,0,1,.37.05,1.61,1.61,0,0,1,.33.12l.12.06.12.08.12.07.11.06a1,1,0,0,1,.22.19.37.37,0,0,1,.08.21.37.37,0,0,1-.09.23,1.06,1.06,0,0,1-.27.22,1.61,1.61,0,0,1-.39.16,1.74,1.74,0,0,1-.39.05,1.49,1.49,0,0,1-.36-.05,1.61,1.61,0,0,1-.33-.12l-.11-.07-.13-.07-.12-.07Zm1.2-.68a.88.88,0,0,0-.42-.09.77.77,0,0,0-.39.11c-.12.07-.19.14-.19.22s.05.17.17.24l.21.13.23.12a.76.76,0,0,0,.41.1.77.77,0,0,0,.39-.11c.12-.07.19-.14.19-.23s-.05-.16-.17-.23l-.21-.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.13,290.42a1.23,1.23,0,0,1,.64-.2,1.08,1.08,0,0,1,.59.14.5.5,0,0,1,.24.24.27.27,0,0,1-.06.26l1,.17h0l0,0,0,0-.22.13-.1,0h-.09l-.94-.15-.35.2.61.35a.05.05,0,0,1,0,0s0,0,0,0l-.21.12-.07,0-.07,0-1.68-1s0,0,0,0a.05.05,0,0,1,0,0Zm.43.69.37-.21a.54.54,0,0,0,.19-.17c0-.05,0-.11-.11-.17a.49.49,0,0,0-.28-.06.86.86,0,0,0-.29.11l-.38.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.84,290l.07,0,.07,0,.18.11s0,0,0,0a.05.05,0,0,1,0,0l-1.14.66h-.14l-1.68-1a.05.05,0,0,1,0,0s0,0,0,0l1.12-.65.07,0,.07,0,.19.11a.05.05,0,0,1,0,0l0,0-.84.48.41.24.78-.45.07,0,.07,0,.19.11s0,0,0,0a.05.05,0,0,1,0,0l-.79.45.44.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.51,289l-.36-.78a.1.1,0,0,0,0,0s0,0,.05-.06l.18-.1.07,0,.07,0,1.68,1s0,0,0,0a.05.05,0,0,1,0,0l-.21.12-.07,0-.07,0-1-.59.25.54s0,0,0,0,0,0,0,.05l-.14.08-.08,0h-.08l-.92-.14,1,.59s0,0,0,0,0,0,0,0l-.21.12-.07,0-.07,0-1.68-1s0,0,0,0a0,0,0,0,1,0,0l.18-.1a.23.23,0,0,1,.11,0h.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.33,288.36l-.07,0-.07,0-1.68-1s0,0,0,0,0,0,0,0l.21-.12.07,0,.07,0,1.68,1s0,0,0,0a.05.05,0,0,1,0,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,286.47a1.41,1.41,0,0,1,.64-.2,1.11,1.11,0,0,1,.61.15c.19.11.28.23.26.36s-.13.24-.34.37l-.42.24.58.33a.05.05,0,0,1,0,0s0,0,0,0l-.21.12s0,0-.07,0a.1.1,0,0,1-.07,0l-1.68-1s0,0,0,0a.08.08,0,0,1,0,0Zm.43.73.4-.23a.42.42,0,0,0,.18-.17c0-.06,0-.12-.11-.17a.46.46,0,0,0-.29-.07.73.73,0,0,0-.3.11l-.4.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.51,285.55a1.19,1.19,0,0,1,.35-.15l.34-.06a1.38,1.38,0,0,1,.29,0l.21.06a.05.05,0,0,1,0,0s0,0,0,0l-.18.11-.09,0h-.32a.77.77,0,0,0-.28.11.31.31,0,0,0-.11.08l-.07.08a.11.11,0,0,0,0,.08s0,0,.06.07a.28.28,0,0,0,.12,0,.4.4,0,0,0,.15,0l.21-.06.29-.1a2,2,0,0,1,.35-.11,1.6,1.6,0,0,1,.29-.05,1,1,0,0,1,.25,0,.63.63,0,0,1,.23.08.41.41,0,0,1,.16.16.25.25,0,0,1,0,.19.52.52,0,0,1-.13.2.86.86,0,0,1-.27.2,1.23,1.23,0,0,1-.31.14,1.4,1.4,0,0,1-.34.08,1.71,1.71,0,0,1-.32,0,.61.61,0,0,1-.28-.08s0,0,0,0a.05.05,0,0,1,0,0l.18-.1.08,0h.09l.11,0h.13l.15,0,.19-.09.13-.09a.17.17,0,0,0,.09-.1.1.1,0,0,0,0-.09.1.1,0,0,0-.06-.07.28.28,0,0,0-.13,0l-.18,0-.23.08-.31.11-.3.09-.27,0-.24,0a.77.77,0,0,1-.23-.1.36.36,0,0,1-.17-.15.23.23,0,0,1,0-.18.38.38,0,0,1,.11-.19A.62.62,0,0,1,202.51,285.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,284.14l.07,0,.07,0,1.06.61a1.09,1.09,0,0,1,.25.2.31.31,0,0,1,.08.21.35.35,0,0,1-.09.22,1.33,1.33,0,0,1-.27.22,1.5,1.5,0,0,1-.38.15,1.19,1.19,0,0,1-.37.06,1.5,1.5,0,0,1-.37-.05,1.4,1.4,0,0,1-.33-.15l-1.07-.61s0,0,0,0,0,0,0,0l.21-.12.07,0,.07,0,1.05.6a.53.53,0,0,0,.21.09l.21,0a.63.63,0,0,0,.19,0,.75.75,0,0,0,.18-.08.57.57,0,0,0,.14-.11.17.17,0,0,0,.06-.11.19.19,0,0,0,0-.12.44.44,0,0,0-.16-.12l-1.05-.61s0,0,0,0,0,0,0,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.24,283.92l-.36-.78a.43.43,0,0,1,0-.05s0,0,0-.06l.18-.1.07,0,.07,0,1.68,1s0,0,0,0a.05.05,0,0,1,0,0l-.21.12-.07,0-.07,0-1-.59.25.54v0a.05.05,0,0,1,0,.05l-.14.08-.08,0h-.08l-.92-.15,1,.59s0,0,0,0,0,0,0,0l-.21.12-.07,0-.07,0-1.68-1s0,0,0,0a.05.05,0,0,1,0,0l.18-.1a.2.2,0,0,1,.11,0h.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.93,255a.29.29,0,0,1-.14,0,.12.12,0,0,1,0-.09l.25-1.22,0-.09a.18.18,0,0,1,.07-.08l.43-.24a.23.23,0,0,1,.14,0,.24.24,0,0,1,.15,0l3.53,2s.06.05,0,.08,0,.07-.06.09l-.44.26a.32.32,0,0,1-.14,0,.33.33,0,0,1-.15,0l-2.7-1.56-.17.8a.08.08,0,0,1-.07.07.38.38,0,0,1-.16,0Z",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.72,251.87l.23.13.26.15.26.15.22.13a2.57,2.57,0,0,1,.49.4.73.73,0,0,1,.22.41.61.61,0,0,1-.14.44,1.71,1.71,0,0,1-.56.45,2.78,2.78,0,0,1-.79.33,2.74,2.74,0,0,1-.75.08,2.86,2.86,0,0,1-.72-.13,4,4,0,0,1-.68-.28l-.49-.27c-.17-.1-.33-.19-.46-.28a3,3,0,0,1-.49-.39.73.73,0,0,1-.23-.43.63.63,0,0,1,.12-.44,1.82,1.82,0,0,1,.56-.45,2.78,2.78,0,0,1,.79-.33,2.65,2.65,0,0,1,1.48.05A4.43,4.43,0,0,1,261.72,251.87Zm-1.25,1.82a2.1,2.1,0,0,0,.79.24,1.27,1.27,0,0,0,.76-.19c.25-.15.36-.29.33-.44a1,1,0,0,0-.42-.46l-.45-.27-.47-.26a2.2,2.2,0,0,0-.8-.24,1.24,1.24,0,0,0-.75.19c-.26.15-.37.29-.33.44a1,1,0,0,0,.42.46l.45.27Z",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.62,250.25a1.59,1.59,0,0,1,.41-.16,1.52,1.52,0,0,1,.77,0,1.33,1.33,0,0,1,.32.11l.31.17.29.18a.66.66,0,0,1,.19.18.32.32,0,0,1,.06.21.37.37,0,0,1-.09.23,1,1,0,0,1-.3.24,2.28,2.28,0,0,1-.4.17,1.9,1.9,0,0,1-.4.05,1.45,1.45,0,0,1-.37,0,1.25,1.25,0,0,1-.31-.1l-.32-.17-.29-.18a1.11,1.11,0,0,1-.19-.18.43.43,0,0,1-.06-.22.4.4,0,0,1,.09-.23A1.05,1.05,0,0,1,261.62,250.25Zm1.52.55-.1-.07-.14-.08-.15-.08-.11-.06a.71.71,0,0,0-.26-.07.55.55,0,0,0-.29.08c-.11.07-.15.12-.14.17a.23.23,0,0,0,.11.15l.1.07.14.08.15.09.11,0a.84.84,0,0,0,.26.07.61.61,0,0,0,.3-.08c.1-.06.15-.12.14-.17A.22.22,0,0,0,263.14,250.8Zm.8-1.73a.14.14,0,0,1,0-.09.19.19,0,0,1,.09-.09l.33-.19a.27.27,0,0,1,.12,0,.16.16,0,0,1,.12,0l0,0,0,0,.85,3.6a.27.27,0,0,1,0,.09s0,0-.09.08l-.33.19a.2.2,0,0,1-.13,0l-.11,0s0,0,0,0,0,0,0,0Zm2,.92a1.59,1.59,0,0,1,.41-.16,1.84,1.84,0,0,1,.4-.06,2.21,2.21,0,0,1,.37,0,1.85,1.85,0,0,1,.31.11l.31.17.3.18a.62.62,0,0,1,.18.18.35.35,0,0,1,.07.21.43.43,0,0,1-.1.23.92.92,0,0,1-.29.24,1.62,1.62,0,0,1-.41.17,1.83,1.83,0,0,1-.4,0,1.5,1.5,0,0,1-.37,0,1.41,1.41,0,0,1-.31-.1l-.31-.17a2.45,2.45,0,0,1-.29-.18.66.66,0,0,1-.19-.18.3.3,0,0,1-.06-.22.4.4,0,0,1,.09-.23A.92.92,0,0,1,265.9,250Zm1.52.55-.1-.06-.15-.09-.14-.08-.11-.06a.77.77,0,0,0-.26-.07.57.57,0,0,0-.29.09c-.11.06-.16.11-.15.17a.26.26,0,0,0,.12.14l.1.07.14.08.15.09.11.05a.77.77,0,0,0,.26.07.48.48,0,0,0,.29-.08c.11-.06.15-.12.14-.17A.29.29,0,0,0,267.42,250.54Z",
    style: {
      fill: "#366E47"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M255.93,255a.29.29,0,0,1-.14,0,.12.12,0,0,1,0-.09l.25-1.22,0-.09a.18.18,0,0,1,.07-.08l.43-.24a.23.23,0,0,1,.14,0,.24.24,0,0,1,.15,0l3.53,2s.06.05,0,.08,0,.07-.06.09l-.44.26a.32.32,0,0,1-.14,0,.33.33,0,0,1-.15,0l-2.7-1.56-.17.8a.08.08,0,0,1-.07.07.38.38,0,0,1-.16,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M261.72,251.87l.23.13.26.15.26.15.22.13a2.57,2.57,0,0,1,.49.4.73.73,0,0,1,.22.41.61.61,0,0,1-.14.44,1.71,1.71,0,0,1-.56.45,2.78,2.78,0,0,1-.79.33,2.74,2.74,0,0,1-.75.08,2.86,2.86,0,0,1-.72-.13,4,4,0,0,1-.68-.28l-.49-.27c-.17-.1-.33-.19-.46-.28a3,3,0,0,1-.49-.39.73.73,0,0,1-.23-.43.63.63,0,0,1,.12-.44,1.82,1.82,0,0,1,.56-.45,2.78,2.78,0,0,1,.79-.33,2.65,2.65,0,0,1,1.48.05A4.43,4.43,0,0,1,261.72,251.87Zm-1.25,1.82a2.1,2.1,0,0,0,.79.24,1.27,1.27,0,0,0,.76-.19c.25-.15.36-.29.33-.44a1,1,0,0,0-.42-.46l-.45-.27-.47-.26a2.2,2.2,0,0,0-.8-.24,1.24,1.24,0,0,0-.75.19c-.26.15-.37.29-.33.44a1,1,0,0,0,.42.46l.45.27Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M261.62,250.25a1.59,1.59,0,0,1,.41-.16,1.52,1.52,0,0,1,.77,0,1.33,1.33,0,0,1,.32.11l.31.17.29.18a.66.66,0,0,1,.19.18.32.32,0,0,1,.06.21.37.37,0,0,1-.09.23,1,1,0,0,1-.3.24,2.28,2.28,0,0,1-.4.17,1.9,1.9,0,0,1-.4.05,1.45,1.45,0,0,1-.37,0,1.25,1.25,0,0,1-.31-.1l-.32-.17-.29-.18a1.11,1.11,0,0,1-.19-.18.43.43,0,0,1-.06-.22.4.4,0,0,1,.09-.23A1.05,1.05,0,0,1,261.62,250.25Zm1.52.55-.1-.07-.14-.08-.15-.08-.11-.06a.71.71,0,0,0-.26-.07.55.55,0,0,0-.29.08c-.11.07-.15.12-.14.17a.23.23,0,0,0,.11.15l.1.07.14.08.15.09.11,0a.84.84,0,0,0,.26.07.61.61,0,0,0,.3-.08c.1-.06.15-.12.14-.17A.22.22,0,0,0,263.14,250.8Zm.8-1.73a.14.14,0,0,1,0-.09.19.19,0,0,1,.09-.09l.33-.19a.27.27,0,0,1,.12,0,.16.16,0,0,1,.12,0l0,0,0,0,.85,3.6a.27.27,0,0,1,0,.09s0,0-.09.08l-.33.19a.2.2,0,0,1-.13,0l-.11,0s0,0,0,0,0,0,0,0Zm2,.92a1.59,1.59,0,0,1,.41-.16,1.84,1.84,0,0,1,.4-.06,2.21,2.21,0,0,1,.37,0,1.85,1.85,0,0,1,.31.11l.31.17.3.18a.62.62,0,0,1,.18.18.35.35,0,0,1,.07.21.43.43,0,0,1-.1.23.92.92,0,0,1-.29.24,1.62,1.62,0,0,1-.41.17,1.83,1.83,0,0,1-.4,0,1.5,1.5,0,0,1-.37,0,1.41,1.41,0,0,1-.31-.1l-.31-.17a2.45,2.45,0,0,1-.29-.18.66.66,0,0,1-.19-.18.3.3,0,0,1-.06-.22.4.4,0,0,1,.09-.23A.92.92,0,0,1,265.9,250Zm1.52.55-.1-.06-.15-.09-.14-.08-.11-.06a.77.77,0,0,0-.26-.07.57.57,0,0,0-.29.09c-.11.06-.16.11-.15.17a.26.26,0,0,0,.12.14l.1.07.14.08.15.09.11.05a.77.77,0,0,0,.26.07.48.48,0,0,0,.29-.08c.11-.06.15-.12.14-.17A.29.29,0,0,0,267.42,250.54Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M238.13,268.36l-.11-.06a.25.25,0,0,1-.1-.31.21.21,0,0,1,.19-.11l1.36-.79a.21.21,0,1,1,.21.37Zm-1.52-.92a.2.2,0,0,1-.11,0l-1.48-.86a.21.21,0,0,1-.08-.29.21.21,0,0,1,.29-.08l1.48.86a.2.2,0,0,1,.08.29A.2.2,0,0,1,236.61,267.44Zm4.45-.8a.21.21,0,0,1-.11-.4l1.48-.86a.22.22,0,0,1,.22.37l-1.49.86A.19.19,0,0,1,241.06,266.64Zm-7.42-.91-.11,0-1.48-.85a.21.21,0,0,1-.08-.29.21.21,0,0,1,.29-.08l1.49.85a.22.22,0,0,1,.08.3A.23.23,0,0,1,233.64,265.73Zm10.38-.81a.2.2,0,0,1-.18-.1.22.22,0,0,1,.07-.3l1.49-.85a.21.21,0,0,1,.21.37l-1.48.86A.22.22,0,0,1,244,264.92Zm3-1.71a.21.21,0,0,1-.11-.4l1.48-.85a.21.21,0,0,1,.29.07.22.22,0,0,1-.07.3l-1.49.85A.19.19,0,0,1,247,263.21Zm3-1.71a.21.21,0,0,1-.18-.11.21.21,0,0,1,.08-.29l1.48-.86a.22.22,0,0,1,.21.38l-1.48.85A.2.2,0,0,1,250,261.5Zm3-1.71a.21.21,0,0,1-.11-.4l1.18-.68a.21.21,0,1,1,.21.37l-1.17.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.51,260.21l.07,0,.07,0,.19.11s0,0,0,0a0,0,0,0,1,0,0l-1.14.66h-.14l-1.68-1,0,0s0,0,0,0l.21-.13h.14l1.42.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.92,259.61a1.44,1.44,0,0,1-.22-.19.37.37,0,0,1-.08-.21.37.37,0,0,1,.09-.23.8.8,0,0,1,.27-.22,1.61,1.61,0,0,1,.39-.16,1.73,1.73,0,0,1,.38-.05,1.5,1.5,0,0,1,.37.05,1.61,1.61,0,0,1,.33.12l.11.07.13.07.12.07.11.06a1.44,1.44,0,0,1,.22.19.33.33,0,0,1,0,.44,1.06,1.06,0,0,1-.27.22,1.61,1.61,0,0,1-.39.16,1.74,1.74,0,0,1-.39.05,1.49,1.49,0,0,1-.36-.05,1.61,1.61,0,0,1-.33-.12l-.11-.06-.13-.08-.12-.07Zm1.19-.67a.74.74,0,0,0-.41-.1.77.77,0,0,0-.39.11c-.12.07-.19.14-.19.23s.05.16.17.23l.21.13.23.13a.85.85,0,0,0,.41.09.77.77,0,0,0,.39-.11c.12-.07.19-.14.19-.22s-.05-.17-.17-.24l-.21-.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.86,257.71a1.33,1.33,0,0,1,.64-.2,1.08,1.08,0,0,1,.59.14.54.54,0,0,1,.24.24.26.26,0,0,1-.06.26l1,.17h0l0,0s0,0,0,0l-.22.13-.1,0h-.09l-.94-.16-.35.2.61.35a.05.05,0,0,1,0,0s0,0,0,0l-.21.13h-.14l-1.68-1,0,0a.05.05,0,0,1,0-.05Zm.43.69.37-.21a.54.54,0,0,0,.19-.17s0-.11-.11-.17a.49.49,0,0,0-.28-.06,1.15,1.15,0,0,0-.29.11l-.38.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.57,257.29h.14l.18.11s0,0,0,0,0,0,0,0l-1.14.66-.07,0-.07,0-1.68-1s0,0,0,0,0,0,0,0l1.12-.65a.08.08,0,0,1,.07,0h.07l.18.11s0,0,0,0a.05.05,0,0,1,0,0l-.84.48.42.24.78-.45.07,0,.07,0,.19.11a.05.05,0,0,1,0,0l0,0-.79.45.43.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.24,256.25l-.36-.78a.11.11,0,0,0,0-.05s0,0,.05-.06l.18-.1.07,0,.07,0,1.68,1s0,0,0,0a.05.05,0,0,1,0,0l-.21.12-.07,0-.07,0-1-.59.25.54s0,0,0,0a.05.05,0,0,1,0,.05l-.14.08-.08,0h-.08l-.92-.15,1,.59s0,0,0,0,0,0,0,0l-.21.12-.07,0-.07,0-1.68-1s0,0,0,0,0,0,0,0l.18-.1a.2.2,0,0,1,.11,0h.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.06,255.65l-.07,0-.07,0-1.68-1s0,0,0,0a.05.05,0,0,1,0,0l.21-.12.07,0,.07,0,1.68,1s0,0,0,0,0,0,0,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.69,253.76a1.39,1.39,0,0,1,.64-.19,1,1,0,0,1,.61.15c.19.11.27.22.26.35s-.13.25-.34.37l-.42.24.58.33a.05.05,0,0,1,0,0,.05.05,0,0,1,0,0l-.22.13h-.14l-1.68-1s0,0,0,0,0,0,0-.05Zm.43.73.4-.23a.42.42,0,0,0,.18-.17c0-.06,0-.12-.11-.17a.48.48,0,0,0-.3-.07,1,1,0,0,0-.29.11l-.4.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.24,252.84a1.19,1.19,0,0,1,.35-.15l.34-.06a1.38,1.38,0,0,1,.29,0l.21.07s0,0,0,0l0,0-.19.1a.13.13,0,0,1-.08,0h-.32a.77.77,0,0,0-.28.11.31.31,0,0,0-.11.08.18.18,0,0,0-.07.09.19.19,0,0,0,0,.08.22.22,0,0,0,.07.06.28.28,0,0,0,.12,0,.27.27,0,0,0,.15,0l.2-.06.3-.1a1.75,1.75,0,0,1,.35-.11,1.6,1.6,0,0,1,.29,0,1,1,0,0,1,.25,0,.92.92,0,0,1,.23.09.34.34,0,0,1,.16.15.25.25,0,0,1,0,.19.52.52,0,0,1-.13.2.86.86,0,0,1-.27.2,1.23,1.23,0,0,1-.31.14,1.51,1.51,0,0,1-.34.08.86.86,0,0,1-.32,0,.77.77,0,0,1-.28-.07s0,0,0-.05a.05.05,0,0,1,0,0l.18-.1.08,0h.09l.11,0h.13l.15,0,.18-.08a.85.85,0,0,0,.14-.1.38.38,0,0,0,.09-.09s0-.07,0-.09a.09.09,0,0,0-.06-.08.28.28,0,0,0-.13,0l-.18,0-.23.08-.31.11-.3.09-.27,0a1,1,0,0,1-.24,0,.67.67,0,0,1-.23-.1.36.36,0,0,1-.17-.15.23.23,0,0,1,0-.18.44.44,0,0,1,.1-.19A1.25,1.25,0,0,1,270.24,252.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.73,251.43l.07,0,.07,0,1.06.62a.86.86,0,0,1,.25.19.37.37,0,0,1,.08.21.35.35,0,0,1-.09.22,1.06,1.06,0,0,1-.27.22,1.8,1.8,0,0,1-.38.16,1.57,1.57,0,0,1-.37,0,1.5,1.5,0,0,1-.37,0,1.43,1.43,0,0,1-.34-.14l-1.06-.62s0,0,0,0,0,0,0,0l.21-.12.07,0,.07,0,1,.61a.6.6,0,0,0,.21.08.76.76,0,0,0,.21,0,.63.63,0,0,0,.19,0,.75.75,0,0,0,.18-.08.4.4,0,0,0,.14-.11.14.14,0,0,0,.06-.11.19.19,0,0,0,0-.12.74.74,0,0,0-.16-.12l-1.05-.61s0,0,0,0a.05.05,0,0,1,0,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,251.21l-.36-.78a.11.11,0,0,0,0-.05s0,0,0-.06l.18-.1.07,0,.07,0,1.68,1s0,0,0,0,0,0,0,0l-.21.12-.07,0-.07,0-1-.58.25.53v0a.05.05,0,0,1,0,.05l-.14.08-.08,0h-.08l-.92-.15,1,.59a.05.05,0,0,1,0,0s0,0,0,0l-.21.12a.13.13,0,0,1-.14,0l-1.68-1s0,0,0,0a.05.05,0,0,1,0,0l.18-.1a.19.19,0,0,1,.1,0h.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcom);
export default __webpack_public_path__ + "static/media/Mcom.e0136a2f274b199f11d1dc45d4b742f3.svg";
export { ForwardRef as ReactComponent };